import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.parse-int.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { LocationServiceStatus } from "../utils";
import Base from "./Base";
import { computed, observable, makeObservable, runInAction, action, reaction } from "mobx";
import DPServices, { UserTypes } from "@dp/services";
import LoginModal from "./models/LoginModal";
import AnalyticsModel from "./models/AnalyticsModel";
import Errors, { ERROR_STRINGS } from "./Errors";
import { ActiveInputField, SignUpModel, UserProfileModel } from "./models";
import { handle, PlatformType, PushNotificationAuthorizationStatus, CapabilityPermissionStatus, convertFromString, getEnvProps, DATE_CONSIDERATIONS } from "@dp/common";
import gt from "lodash/gt";
import isEqual from "lodash/isEqual";
import toInteger from "lodash/toInteger";
import { JoinEclubModel } from "./models/JoinEclubModel";
import moment from "moment";
import i18next from "i18next";
import { merge } from "lodash";
var SECURE_STORE_CRDS_KEY = "APP_CRDS";
var User = (_class = /*#__PURE__*/function (_Base) {
  _inherits(User, _Base);

  var _super = _createSuper(User); // public joinWaitlistModel: JoinWaitlistModel;


  function User(rootStore) {
    var _this;

    _classCallCheck(this, User);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "sessionDetails", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "userProfile", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "profileResponse", _descriptor3, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "loginModal", void 0);

    _defineProperty(_assertThisInitialized(_this), "analyticsModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "signUpModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "userProfileModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "joinEclubModel", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "savedCreds", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "isAuthenticated", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "foreGroundLocationPermissions", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "backGroundLocationPermissions", _descriptor7, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "deviceAuth", _descriptor8, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "currentUserLocation", _descriptor9, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_promptForLocationPermissions", _descriptor10, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "pushNotificationAuthorizationStatus", _descriptor11, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "photoLibraryPermissionStatus", _descriptor12, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_promptForPhotoLibraryPermissions", _descriptor13, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_showHomeScreenAlert", _descriptor14, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_restaurantNumToBeSavedInUserProfile", _descriptor15, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isHomeScreenAlertClosed", _descriptor16, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isOrderSummaryOpen", _descriptor17, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_favoriteLocations", _descriptor18, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_authInProgress", _descriptor19, _assertThisInitialized(_this));

    makeObservable(_assertThisInitialized(_this));
    _this.loginModal = new LoginModal();
    _this.signUpModel = new SignUpModel(rootStore.platformUtil);
    _this.userProfileModel = new UserProfileModel(); // this.joinWaitlistModel = new JoinWaitlistModel();

    _this.joinEclubModel = new JoinEclubModel();
    _this.rootStore = rootStore;
    _this.analyticsModel = new AnalyticsModel(rootStore.platformUtil);

    _this.analyticsModel.setChangeErrorPageNameWithoutRD(true);

    return _this;
  }

  _createClass(User, [{
    key: "setupReactions",
    value: function setupReactions() {
      var _this2 = this;

      reaction(function () {
        var _this2$loginModal;

        return {
          disableAutoLogin: (_this2$loginModal = _this2.loginModal) === null || _this2$loginModal === void 0 ? void 0 : _this2$loginModal.disableAutoLogin
        };
      }, function (data) {
        _this2.rootStore.platformUtil.saveInSecureStore("DISABLE_AUTO_LOGIN", data.disableAutoLogin.toString());
      }); // reaction to update app attributes in analytics model

      reaction(function () {
        return {
          appAttributes: _this2.rootStore.common.appAttributes
        };
      }, function (data) {
        if (data !== null && data !== void 0 && data.appAttributes) {
          _this2.analyticsModel.setAppAttributes(data === null || data === void 0 ? void 0 : data.appAttributes);

          _this2.userProfileModel.setAppAttributes(data.appAttributes);

          _this2.joinEclubModel.setAppAttributes(data === null || data === void 0 ? void 0 : data.appAttributes);
        }
      }); // reaction takes care when the session-api gives transient as true, but is not handled, and user-profile is present, thus enforcing for the new-session.

      reaction(function () {
        return {
          isLoggedIn: _this2.isLoggedIn
        };
      }, function (data) {
        if (!data.isLoggedIn && _this2.userProfile) {
          _this2.rootStore.appMessages.showError("Session Expired", "Your session has expired due to an extended period of inactivity.", null, {
            undismissible: true,
            okBtnText: "Ok",
            okBtnOnClick: function okBtnOnClick() {
              _this2.rootStore.reloadApp();
            }
          });
        }
      }); // reaction takes care of populating the pref. location data from the user-profile

      reaction(function () {
        return {
          isLoggedIn: _this2.isLoggedIn,
          userProfile: _this2.userProfile
        };
      }, function (data) {
        if (data !== null && data !== void 0 && data.isLoggedIn) {
          var _this2$userProfileMod, _data$userProfile;

          (_this2$userProfileMod = _this2.userProfileModel) === null || _this2$userProfileMod === void 0 ? void 0 : _this2$userProfileMod.setPreferredRestaurantDetails(data === null || data === void 0 ? void 0 : (_data$userProfile = data.userProfile) === null || _data$userProfile === void 0 ? void 0 : _data$userProfile.preferredRestaurantList);
        }
      });
      reaction(function () {
        return {
          activeElement: _this2.userProfileModel.activeInputField
        };
      }, function (data) {
        if ((data === null || data === void 0 ? void 0 : data.activeElement) !== null) {
          var _this2$rootStore, _this2$rootStore$plat;

          (_this2$rootStore = _this2.rootStore) === null || _this2$rootStore === void 0 ? void 0 : (_this2$rootStore$plat = _this2$rootStore.platformUtil) === null || _this2$rootStore$plat === void 0 ? void 0 : _this2$rootStore$plat.dispatchEvent("AnalyticsEvent", "change ".concat(ActiveInputField[data.activeElement], " | open modal"), {});
        }
      });
      return;
    }
  }, {
    key: "fetchSavedCredentials",
    value: function () {
      var _fetchSavedCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var savedCreds;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.savedCreds === null || this.savedCreds === undefined)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return this.getSavedCredentials();

              case 3:
                savedCreds = _context.sent;

                if (savedCreds) {
                  runInAction(function () {
                    _this3.savedCreds = savedCreds;
                  });
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchSavedCredentials() {
        return _fetchSavedCredentials.apply(this, arguments);
      }

      return fetchSavedCredentials;
    }()
  }, {
    key: "dissmissPromptForLocationPermissions",
    value: function () {
      var _dissmissPromptForLocationPermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var forEver,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                forEver = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;

                if (!forEver) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 4;
                return this.rootStore.platformUtil.saveInLocalStorage("DISMISS_LOCATION_PERMISSIONS_PROMPT", "true");

              case 4:
                _context2.next = 8;
                break;

              case 6:
                _context2.next = 8;
                return this.rootStore.platformUtil.saveInSessionStorage("DISMISS_LOCATION_PERMISSIONS_PROMPT", "true");

              case 8:
                this.promptForLocationPermissions = false;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function dissmissPromptForLocationPermissions() {
        return _dissmissPromptForLocationPermissions.apply(this, arguments);
      }

      return dissmissPromptForLocationPermissions;
    }()
  }, {
    key: "dismissPromptForPhotoLibraryPermissions",
    value: function () {
      var _dismissPromptForPhotoLibraryPermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var forEver,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                forEver = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;

                if (!forEver) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 4;
                return this.rootStore.platformUtil.saveInLocalStorage("DISMISS_PHOTO_LIBRARY_PERMISSIONS_PROMPT", "true");

              case 4:
                _context3.next = 8;
                break;

              case 6:
                _context3.next = 8;
                return this.rootStore.platformUtil.saveInSessionStorage("DISMISS_PHOTO_LIBRARY_PERMISSIONS_PROMPT", "true");

              case 8:
                this.promptForPhotoLibraryPermissions = false;

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function dismissPromptForPhotoLibraryPermissions() {
        return _dismissPromptForPhotoLibraryPermissions.apply(this, arguments);
      }

      return dismissPromptForPhotoLibraryPermissions;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return handle(this.rootStore.platformUtil.hydrateUsingLocalStorage("LOGIN_INFO", this.loginModal));

              case 2:
                _context4.next = 4;
                return this.rootStore.platformUtil.getFromSecureStore("DISABLE_AUTO_LOGIN");

              case 4:
                _context4.t0 = _context4.sent;
                this.loginModal.disableAutoLogin = _context4.t0 === "true";
                this.userProfileModel.setAppAttributes(this.rootStore.common.appAttributes); // Making this call only on APP. On web this will be on Demand.

                if (!(this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP)) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 10;
                return this.determineDeviceCapabilities();

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "getAndSetSessionDetails",
    value: function () {
      var _getAndSetSessionDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this4 = this;

        var accessToken, sessionDetails;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.getTokenSilentIfLoggedIn();

              case 2:
                accessToken = _context5.sent;
                _context5.next = 5;
                return DPServices.User.getSessionDetails({
                  jwtToken: accessToken
                });

              case 5:
                sessionDetails = _context5.sent;
                runInAction(function () {
                  _this4.sessionDetails = sessionDetails;
                });
                this.analyticsModel.setSessionDetails(sessionDetails);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getAndSetSessionDetails() {
        return _getAndSetSessionDetails.apply(this, arguments);
      }

      return getAndSetSessionDetails;
    }()
  }, {
    key: "getCurrentUserProfile",
    value: function () {
      var _getCurrentUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var cache,
            token,
            jwtToken,
            userProfile,
            cachedUserProfile,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                cache = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : false;
                token = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : "";
                jwtToken = token;

                if (!(!token || (token === null || token === void 0 ? void 0 : token.length) === 0)) {
                  _context6.next = 7;
                  break;
                }

                _context6.next = 6;
                return this.ensureAuth();

              case 6:
                jwtToken = _context6.sent;

              case 7:
                _context6.prev = 7;
                _context6.next = 10;
                return DPServices.User.getFavoriteLocations(jwtToken);

              case 10:
                this.favoriteLocations = _context6.sent;
                _context6.next = 15;
                break;

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](7);

              case 15:
                userProfile = null;

                if (!cache) {
                  _context6.next = 21;
                  break;
                }

                _context6.next = 19;
                return this.rootStore.platformUtil.getFromLocalStorage("USER_PROFILE");

              case 19:
                cachedUserProfile = _context6.sent;

                if (cachedUserProfile) {
                  userProfile = JSON.parse(cachedUserProfile);
                }

              case 21:
                if (!userProfile) {
                  _context6.next = 26;
                  break;
                }

                this.analyticsModel.setUserDetails(userProfile);
                return _context6.abrupt("return", userProfile);

              case 26:
                _context6.prev = 26;
                _context6.next = 29;
                return DPServices.User.getCurrentUserProfile({
                  jwtToken: jwtToken
                });

              case 29:
                userProfile = _context6.sent;
                this.cacheUserProfile(userProfile);
                this.analyticsModel.setUserDetails(userProfile);
                return _context6.abrupt("return", userProfile);

              case 35:
                _context6.prev = 35;
                _context6.t1 = _context6["catch"](26);
                return _context6.abrupt("return", null);

              case 38:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[7, 13], [26, 35]]);
      }));

      function getCurrentUserProfile() {
        return _getCurrentUserProfile.apply(this, arguments);
      }

      return getCurrentUserProfile;
    }()
  }, {
    key: "refreshCurrentUserProfile",
    value: function () {
      var _refreshCurrentUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _this5 = this;

        var token,
            userProfile,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                token = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : "";
                _context7.next = 3;
                return this.getCurrentUserProfile(false, token);

              case 3:
                userProfile = _context7.sent;
                runInAction(function () {
                  _this5.userProfile = userProfile;
                });

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function refreshCurrentUserProfile() {
        return _refreshCurrentUserProfile.apply(this, arguments);
      }

      return refreshCurrentUserProfile;
    }()
  }, {
    key: "cacheUserProfile",
    value: function () {
      var _cacheUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(profile) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.rootStore.platformUtil.saveInLocalStorage("USER_PROFILE", JSON.stringify(profile)));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function cacheUserProfile(_x) {
        return _cacheUserProfile.apply(this, arguments);
      }

      return cacheUserProfile;
    }()
  }, {
    key: "refreshSessionDetails",
    value: function () {
      var _refreshSessionDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this6 = this;

        var accessToken, sessionDetails;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.getTokenSilentIfLoggedIn();

              case 2:
                accessToken = _context9.sent;
                _context9.next = 5;
                return DPServices.User.getSessionDetails({
                  jwtToken: accessToken
                });

              case 5:
                sessionDetails = _context9.sent;
                runInAction(function () {
                  _this6.sessionDetails = sessionDetails;
                });
                this.analyticsModel.setSessionDetails(sessionDetails);

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function refreshSessionDetails() {
        return _refreshSessionDetails.apply(this, arguments);
      }

      return refreshSessionDetails;
    }() // below method will be called on common init after msal instance is initialized

  }, {
    key: "checkUserInitialLoggedInStatus",
    value: function () {
      var _checkUserInitialLoggedInStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var _this7 = this;

        var _getEnvProps, BYPASS_BIOMETRIC_AUTH_FOR_SAVED_CREDS, userProfile;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _getEnvProps = getEnvProps(), BYPASS_BIOMETRIC_AUTH_FOR_SAVED_CREDS = _getEnvProps.BYPASS_BIOMETRIC_AUTH_FOR_SAVED_CREDS;

                if (!(this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB || BYPASS_BIOMETRIC_AUTH_FOR_SAVED_CREDS && BYPASS_BIOMETRIC_AUTH_FOR_SAVED_CREDS === "true")) {
                  _context10.next = 4;
                  break;
                }

                _context10.next = 4;
                return this.trySilentLogin();

              case 4:
                if (!this.isLoggedIn) {
                  _context10.next = 9;
                  break;
                }

                _context10.next = 7;
                return this.getCurrentUserProfile(true);

              case 7:
                userProfile = _context10.sent;
                runInAction(function () {
                  _this7.userProfile = userProfile;
                  _this7.isAuthenticated = true;
                });

              case 9:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function checkUserInitialLoggedInStatus() {
        return _checkUserInitialLoggedInStatus.apply(this, arguments);
      }

      return checkUserInitialLoggedInStatus;
    }()
  }, {
    key: "determineLocationPermissionsPromptState",
    value: function () {
      var _determineLocationPermissionsPromptState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var foreGroundLocationPermissions, localLevel, sessionLevel;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                foreGroundLocationPermissions = this.foregroundLocationPermissionGranted;

                if (!foreGroundLocationPermissions) {
                  _context11.next = 9;
                  break;
                }

                _context11.next = 4;
                return this.rootStore.platformUtil.removeFromLocalStorage("DISMISS_LOCATION_PERMISSIONS_PROMPT");

              case 4:
                _context11.next = 6;
                return this.rootStore.platformUtil.removeFromSessionStorage("DISMISS_LOCATION_PERMISSIONS_PROMPT");

              case 6:
                this.promptForLocationPermissions = false;
                _context11.next = 16;
                break;

              case 9:
                _context11.next = 11;
                return this.rootStore.platformUtil.getFromLocalStorage("DISMISS_LOCATION_PERMISSIONS_PROMPT");

              case 11:
                localLevel = _context11.sent;
                _context11.next = 14;
                return this.rootStore.platformUtil.getFromSessionStorage("DISMISS_LOCATION_PERMISSIONS_PROMPT");

              case 14:
                sessionLevel = _context11.sent;

                if (sessionLevel === "true") {
                  this.promptForLocationPermissions = false;
                } else {
                  if (localLevel === "true") {
                    this.promptForLocationPermissions = false;
                  } else {
                    this.promptForLocationPermissions = true;
                  }
                }

              case 16:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function determineLocationPermissionsPromptState() {
        return _determineLocationPermissionsPromptState.apply(this, arguments);
      }

      return determineLocationPermissionsPromptState;
    }()
  }, {
    key: "determinePhotoLibraryPermissionsPromptState",
    value: function () {
      var _determinePhotoLibraryPermissionsPromptState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _this8 = this;

        var newPermission, oldPermissions;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.rootStore.platformUtil.getPhotoLibraryPermissions();

              case 2:
                newPermission = _context12.sent;
                oldPermissions = this.photoLibraryPermissionStatus;

                if (!oldPermissions) {
                  _context12.next = 22;
                  break;
                }

                if (!(oldPermissions === CapabilityPermissionStatus.DENIED || oldPermissions === CapabilityPermissionStatus.BLOCKED)) {
                  _context12.next = 14;
                  break;
                }

                if (!(newPermission === CapabilityPermissionStatus.GRANTED || newPermission === CapabilityPermissionStatus.LIMITED)) {
                  _context12.next = 10;
                  break;
                }

                this.rootStore.platformUtil.requestPhotoLibraryPermission();
                _context12.next = 12;
                break;

              case 10:
                _context12.next = 12;
                return this.handlePhotoLibraryPermissionsDenied();

              case 12:
                _context12.next = 20;
                break;

              case 14:
                if (!(newPermission === CapabilityPermissionStatus.DENIED)) {
                  _context12.next = 17;
                  break;
                }

                _context12.next = 17;
                return this.handlePhotoLibraryPermissionsDenied();

              case 17:
                if (!(newPermission === CapabilityPermissionStatus.GRANTED)) {
                  _context12.next = 20;
                  break;
                }

                _context12.next = 20;
                return this.handlePhotoLibraryPermissionAuthorized();

              case 20:
                _context12.next = 34;
                break;

              case 22:
                if (!(newPermission === CapabilityPermissionStatus.UNAVAILABLE)) {
                  _context12.next = 27;
                  break;
                }

                _context12.next = 25;
                return this.dismissPromptForPhotoLibraryPermissions(true);

              case 25:
                _context12.next = 34;
                break;

              case 27:
                if (!(newPermission === CapabilityPermissionStatus.GRANTED || newPermission === CapabilityPermissionStatus.LIMITED)) {
                  _context12.next = 32;
                  break;
                }

                _context12.next = 30;
                return this.handlePhotoLibraryPermissionAuthorized();

              case 30:
                _context12.next = 34;
                break;

              case 32:
                _context12.next = 34;
                return this.handlePhotoLibraryPermissionsDenied();

              case 34:
                runInAction(function () {
                  _this8.photoLibraryPermissionStatus = newPermission;
                });

              case 35:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function determinePhotoLibraryPermissionsPromptState() {
        return _determinePhotoLibraryPermissionsPromptState.apply(this, arguments);
      }

      return determinePhotoLibraryPermissionsPromptState;
    }()
  }, {
    key: "handlePhotoLibraryPermissionsDenied",
    value: function () {
      var _handlePhotoLibraryPermissionsDenied = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var localLevel, sessionLevel;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.rootStore.platformUtil.getFromLocalStorage("DISMISS_PHOTO_LIBRARY_PERMISSIONS_PROMPT");

              case 2:
                localLevel = _context13.sent;
                _context13.next = 5;
                return this.rootStore.platformUtil.getFromSessionStorage("DISMISS_PHOTO_LIBRARY_PERMISSIONS_PROMPT");

              case 5:
                sessionLevel = _context13.sent;

                if (sessionLevel === "true") {
                  this.promptForPhotoLibraryPermissions = false;
                } else {
                  if (localLevel === "true") {
                    this.promptForPhotoLibraryPermissions = false;
                  } else {
                    this.promptForPhotoLibraryPermissions = true;
                  }
                }

              case 7:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function handlePhotoLibraryPermissionsDenied() {
        return _handlePhotoLibraryPermissionsDenied.apply(this, arguments);
      }

      return handlePhotoLibraryPermissionsDenied;
    }()
  }, {
    key: "handlePhotoLibraryPermissionAuthorized",
    value: function () {
      var _handlePhotoLibraryPermissionAuthorized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.rootStore.platformUtil.removeFromLocalStorage("DISMISS_PHOTO_LIBRARY_PERMISSIONS_PROMPT");

              case 2:
                _context14.next = 4;
                return this.rootStore.platformUtil.removeFromSessionStorage("DISMISS_PHOTO_LIBRARY_PERMISSIONS_PROMPT");

              case 4:
                this.promptForPhotoLibraryPermissions = false;

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function handlePhotoLibraryPermissionAuthorized() {
        return _handlePhotoLibraryPermissionAuthorized.apply(this, arguments);
      }

      return handlePhotoLibraryPermissionAuthorized;
    }()
  }, {
    key: "processPushNotificationsPermissions",
    value: function () {
      var _processPushNotificationsPermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(pushNotificationPermissions, isFreshInstall) {
        var _this9 = this;

        var token, currSavedToken, permissions;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(pushNotificationPermissions === PushNotificationAuthorizationStatus.AUTHORIZED)) {
                  _context15.next = 11;
                  break;
                }

                runInAction(function () {
                  _this9.pushNotificationAuthorizationStatus = pushNotificationPermissions;
                });
                _context15.next = 4;
                return this.rootStore.platformUtil.registerForPushNotifications();

              case 4:
                token = _context15.sent;
                _context15.next = 7;
                return this.rootStore.platformUtil.getFromLocalStorage("PUSH_NOTIFICATIONS_TOKEN");

              case 7:
                currSavedToken = _context15.sent;

                if (token && (!currSavedToken || currSavedToken !== token)) {
                  this.rootStore.platformUtil.saveInLocalStorage("PUSH_NOTIFICATIONS_TOKEN", token.toString());
                }

                _context15.next = 26;
                break;

              case 11:
                if (!(pushNotificationPermissions === PushNotificationAuthorizationStatus.NOT_DETERMINED || pushNotificationPermissions === PushNotificationAuthorizationStatus.DENIED && isFreshInstall)) {
                  _context15.next = 19;
                  break;
                }

                _context15.next = 14;
                return this.rootStore.platformUtil.requestPushNotificationsPermission();

              case 14:
                permissions = _context15.sent;
                _context15.next = 17;
                return this.processPushNotificationsPermissions(permissions, false);

              case 17:
                _context15.next = 26;
                break;

              case 19:
                if (!(pushNotificationPermissions === PushNotificationAuthorizationStatus.DENIED || pushNotificationPermissions === PushNotificationAuthorizationStatus.PROVISIONAL)) {
                  _context15.next = 25;
                  break;
                }

                runInAction(function () {
                  _this9.pushNotificationAuthorizationStatus = pushNotificationPermissions;
                });
                _context15.next = 23;
                return this.rootStore.platformUtil.removeFromLocalStorage("PUSH_NOTIFICATIONS_TOKEN");

              case 23:
                _context15.next = 26;
                break;

              case 25:
                runInAction(function () {
                  _this9.pushNotificationAuthorizationStatus = pushNotificationPermissions;
                });

              case 26:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function processPushNotificationsPermissions(_x2, _x3) {
        return _processPushNotificationsPermissions.apply(this, arguments);
      }

      return processPushNotificationsPermissions;
    }()
  }, {
    key: "determinePushNotificationsPermissionsPromptState",
    value: function () {
      var _determinePushNotificationsPermissionsPromptState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var isFreshInstall, pushNotificationPermissions;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.rootStore.platformUtil.isFreshInstall();

              case 2:
                isFreshInstall = _context16.sent;
                _context16.next = 5;
                return this.rootStore.platformUtil.getPushNotificationsPermissions();

              case 5:
                pushNotificationPermissions = _context16.sent;
                _context16.next = 8;
                return this.processPushNotificationsPermissions(pushNotificationPermissions, isFreshInstall);

              case 8:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function determinePushNotificationsPermissionsPromptState() {
        return _determinePushNotificationsPermissionsPromptState.apply(this, arguments);
      }

      return determinePushNotificationsPermissionsPromptState;
    }()
  }, {
    key: "determineForegroundLocationPermissionsAndCurrentPosition",
    value: function () {
      var _determineForegroundLocationPermissionsAndCurrentPosition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var foreGroundLocationPermissions, _foreGroundLocationPermissions, position;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.rootStore.platformUtil.getForegroundLocationPermissions();

              case 2:
                foreGroundLocationPermissions = _context17.sent;

                if (!(foreGroundLocationPermissions.status === "undetermined")) {
                  _context17.next = 12;
                  break;
                }

                _context17.next = 6;
                return this.rootStore.platformUtil.getCurrentGeoCoords(false);

              case 6:
                _context17.next = 8;
                return this.rootStore.platformUtil.getForegroundLocationPermissions();

              case 8:
                _foreGroundLocationPermissions = _context17.sent;
                return _context17.abrupt("return", [_foreGroundLocationPermissions, null]);

              case 12:
                if (!foreGroundLocationPermissions.granted) {
                  _context17.next = 19;
                  break;
                }

                _context17.next = 15;
                return this.rootStore.platformUtil.getCurrentGeoCoords(false);

              case 15:
                position = _context17.sent;
                return _context17.abrupt("return", [foreGroundLocationPermissions, position]);

              case 19:
                return _context17.abrupt("return", [foreGroundLocationPermissions, null]);

              case 20:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function determineForegroundLocationPermissionsAndCurrentPosition() {
        return _determineForegroundLocationPermissionsAndCurrentPosition.apply(this, arguments);
      }

      return determineForegroundLocationPermissionsAndCurrentPosition;
    }()
  }, {
    key: "requestBackgroundLocationPermissions",
    value: function () {
      var _requestBackgroundLocationPermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(title, message) {
        var _this10 = this;

        var backGroundLocationPermissions, resultPermissions;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.rootStore.platformUtil.getBackgroundLocationPermissions();

              case 2:
                backGroundLocationPermissions = _context18.sent;

                if (!(backGroundLocationPermissions.granted || backGroundLocationPermissions.canAskAgain || backGroundLocationPermissions.status === "undetermined")) {
                  _context18.next = 10;
                  break;
                }

                _context18.next = 6;
                return this.rootStore.platformUtil.requestBackgroundLocationPermission(title, message);

              case 6:
                resultPermissions = _context18.sent;
                runInAction(function () {
                  _this10.backGroundLocationPermissions = resultPermissions;
                });
                _context18.next = 11;
                break;

              case 10:
                runInAction(function () {
                  _this10.backGroundLocationPermissions = backGroundLocationPermissions;
                });

              case 11:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function requestBackgroundLocationPermissions(_x4, _x5) {
        return _requestBackgroundLocationPermissions.apply(this, arguments);
      }

      return requestBackgroundLocationPermissions;
    }()
  }, {
    key: "determineDeviceCapabilities",
    value: function () {
      var _determineDeviceCapabilities = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var _this11 = this;

        var proceedWithNativeLocationPrompt, _yield$this$determine, _yield$this$determine2, foreGroundLocationPermissions, currentLocation, backGroundLocationPermissions, _yield$Promise$all, _yield$Promise$all2, deviceAuth;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.rootStore.platformUtil.canShowNativeLocationPrompt();

              case 2:
                proceedWithNativeLocationPrompt = _context19.sent;
                this.rootStore.platformUtil.saveInLocalStorage("LOCATION_PROMPT_PERMISSION_FOR_NATIVE_POPUP_GRANTED", proceedWithNativeLocationPrompt.success.toString());

                if (!proceedWithNativeLocationPrompt.success) {
                  _context19.next = 17;
                  break;
                }

                _context19.next = 7;
                return this.determineForegroundLocationPermissionsAndCurrentPosition();

              case 7:
                _yield$this$determine = _context19.sent;
                _yield$this$determine2 = _slicedToArray(_yield$this$determine, 2);
                foreGroundLocationPermissions = _yield$this$determine2[0];
                currentLocation = _yield$this$determine2[1];
                _context19.next = 13;
                return this.rootStore.platformUtil.getBackgroundLocationPermissions();

              case 13:
                backGroundLocationPermissions = _context19.sent;
                runInAction(function () {
                  _this11.foreGroundLocationPermissions = foreGroundLocationPermissions;
                  _this11.backGroundLocationPermissions = backGroundLocationPermissions;

                  if (!_this11.currentUserLocation) {
                    _this11.currentUserLocation = currentLocation;
                  }
                });
                _context19.next = 20;
                break;

              case 17:
                this.foreGroundLocationPermissions = proceedWithNativeLocationPrompt.deniedPermissions;
                this.backGroundLocationPermissions = proceedWithNativeLocationPrompt.deniedPermissions;

                if (!this.currentUserLocation) {
                  this.currentUserLocation = null;
                }

              case 20:
                _context19.next = 22;
                return Promise.all([this.rootStore.platformUtil.determineDeviceAuthSupport(), this.determinePushNotificationsPermissionsPromptState(), this.determinePhotoLibraryPermissionsPromptState()]);

              case 22:
                _yield$Promise$all = _context19.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
                deviceAuth = _yield$Promise$all2[0];
                runInAction(function () {
                  _this11.deviceAuth = deviceAuth;
                });
                _context19.next = 28;
                return Promise.all([this.determineLocationPermissionsPromptState(), this.fetchSavedCredentials()]);

              case 28:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function determineDeviceCapabilities() {
        return _determineDeviceCapabilities.apply(this, arguments);
      }

      return determineDeviceCapabilities;
    }()
  }, {
    key: "obtainUserGeoCoordinates",
    value: function () {
      var _obtainUserGeoCoordinates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(enableHighAccuracy, timeout, maxage) {
        var _this12 = this;

        var initialPermissions, currentLocation;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                if (!(this.currentUserLocation && this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP)) {
                  _context20.next = 2;
                  break;
                }

                return _context20.abrupt("return");

              case 2:
                _context20.next = 4;
                return this.rootStore.platformUtil.getForegroundLocationPermissions();

              case 4:
                initialPermissions = _context20.sent;
                _context20.next = 7;
                return this.rootStore.platformUtil.getCurrentGeoCoords(enableHighAccuracy, timeout, maxage);

              case 7:
                currentLocation = _context20.sent;

                if (currentLocation) {
                  // foreGroundLocationPermissions is undefined on initial page load
                  if (this.foreGroundLocationPermissions === undefined && !initialPermissions.granted) {
                    // Send analytic event when guest allows permission
                    this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "locationEnabled", {});
                  } // set location enabled flag to true


                  runInAction(function () {
                    _this12.foreGroundLocationPermissions = {
                      scope: null,
                      accuracy: null,
                      granted: true,
                      expires: null,
                      canAskAgain: false,
                      status: null
                    };
                  }); // set user coords

                  runInAction(function () {
                    _this12.currentUserLocation = currentLocation;
                  });
                } else {
                  runInAction(function () {
                    _this12.foreGroundLocationPermissions = {
                      scope: null,
                      accuracy: null,
                      granted: false,
                      expires: null,
                      canAskAgain: false,
                      status: null
                    };
                  });
                }

              case 9:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function obtainUserGeoCoordinates(_x6, _x7, _x8) {
        return _obtainUserGeoCoordinates.apply(this, arguments);
      }

      return obtainUserGeoCoordinates;
    }()
  }, {
    key: "updateSession",
    value: function () {
      var _updateSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var _this13 = this;

        var accessToken, sessionDetails;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.getTokenSilentIfLoggedIn();

              case 2:
                accessToken = _context21.sent;
                _context21.next = 5;
                return DPServices.User.getSessionDetails({
                  jwtToken: accessToken
                });

              case 5:
                sessionDetails = _context21.sent;
                runInAction(function () {
                  _this13.sessionDetails = sessionDetails;
                });
                this.analyticsModel.setSessionDetails(sessionDetails);

              case 8:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function updateSession() {
        return _updateSession.apply(this, arguments);
      }

      return updateSession;
    }() // After first add to cart without orderID hydrating session details with orderContext
    // details using cart.order data. This is done to prevent initDetails call after add to cart.

  }, {
    key: "updateSessionOrderContext",
    value: function updateSessionOrderContext(cart) {
      var _cart$order,
          _cart$order2,
          _cart$order3,
          _cart$order4,
          _cart$order5,
          _cart$order6,
          _this$sessionDetails,
          _this$sessionDetails$,
          _cart$order7,
          _cart$order7$commerce,
          _cart$order7$commerce2,
          _cart$order8,
          _cart$order9,
          _this14 = this;

      var actualPickupDateTime = cart !== null && cart !== void 0 && (_cart$order = cart.order) !== null && _cart$order !== void 0 && _cart$order.pickupDate && cart !== null && cart !== void 0 && (_cart$order2 = cart.order) !== null && _cart$order2 !== void 0 && _cart$order2.pickupTime ? moment((cart === null || cart === void 0 ? void 0 : (_cart$order3 = cart.order) === null || _cart$order3 === void 0 ? void 0 : _cart$order3.pickupDate) + " " + (cart === null || cart === void 0 ? void 0 : (_cart$order4 = cart.order) === null || _cart$order4 === void 0 ? void 0 : _cart$order4.pickupTime), DATE_CONSIDERATIONS.DATE_TIME_FORMAT_WITH_SLASH).toDate() : null;

      var _sessionDetails = merge(this.sessionDetails, {
        orderContext: {
          orderTypeValue: cart === null || cart === void 0 ? void 0 : (_cart$order5 = cart.order) === null || _cart$order5 === void 0 ? void 0 : _cart$order5.orderType,
          orderId: cart === null || cart === void 0 ? void 0 : (_cart$order6 = cart.order) === null || _cart$order6 === void 0 ? void 0 : _cart$order6.orderId,
          showCalories: ((_this$sessionDetails = this.sessionDetails) === null || _this$sessionDetails === void 0 ? void 0 : (_this$sessionDetails$ = _this$sessionDetails.orderContext) === null || _this$sessionDetails$ === void 0 ? void 0 : _this$sessionDetails$.showCalories) || true,
          actualPickupDateTime: actualPickupDateTime,
          updated_EDateTime: actualPickupDateTime,
          itemCount: cart === null || cart === void 0 ? void 0 : (_cart$order7 = cart.order) === null || _cart$order7 === void 0 ? void 0 : (_cart$order7$commerce = _cart$order7.commerceItems) === null || _cart$order7$commerce === void 0 ? void 0 : (_cart$order7$commerce2 = _cart$order7$commerce[0]) === null || _cart$order7$commerce2 === void 0 ? void 0 : _cart$order7$commerce2.quantity,
          pickupDate: cart === null || cart === void 0 ? void 0 : (_cart$order8 = cart.order) === null || _cart$order8 === void 0 ? void 0 : _cart$order8.pickupDate,
          pickupTime: cart === null || cart === void 0 ? void 0 : (_cart$order9 = cart.order) === null || _cart$order9 === void 0 ? void 0 : _cart$order9.pickupTime,
          pickupLocationTimeConfirmation: cart === null || cart === void 0 ? void 0 : cart.pickupLocationTimeConfirmation
        },
        asapSelected: cart === null || cart === void 0 ? void 0 : cart.isAsapSelected
      });

      runInAction(function () {
        _this14.sessionDetails = _objectSpread({}, _sessionDetails);
      });
      this.analyticsModel.setSessionDetails(_sessionDetails);
    }
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(error) {
        var clearSavedCredentials,
            takeWebToMenu,
            retainQuery,
            _args22 = arguments;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                clearSavedCredentials = _args22.length > 1 && _args22[1] !== undefined ? _args22[1] : false;
                takeWebToMenu = _args22.length > 2 && _args22[2] !== undefined ? _args22[2] : true;
                retainQuery = _args22.length > 3 && _args22[3] !== undefined ? _args22[3] : false;
                _context22.prev = 3;

                if (error) {
                  this.rootStore.showError(error);
                }

                _context22.next = 7;
                return handle(this.rootStore.platformUtil.clearLocalStorage(["USER_PROFILE", "ORDER_HISTORY", "FREQUENTLY_ORDERED_ITEMS", "FAVORITE_PRODUCTS", "LOCKERS_BY_OWNER", "PROFILE_ORDER_HISTORY", "ORDER_HISTORY_DETAILS", "ORDER_HISTORY_DETAILS_NEW"]));

              case 7:
                _context22.next = 9;
                return this.signOutUsingAzureB2C(retainQuery);

              case 9:
                if (!(this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP)) {
                  _context22.next = 19;
                  break;
                }

                this.loginModal.disableAutoLogin = true;
                this.loginModal.socialProfile = null;
                this.loginModal.promptBiometricAuth = false;

                if (!clearSavedCredentials) {
                  clearSavedCredentials = !(this.deviceAuth.hasHardWare && this.deviceAuth.isEnrolled);
                }

                if (!clearSavedCredentials) {
                  _context22.next = 17;
                  break;
                }

                _context22.next = 17;
                return this.rootStore.platformUtil.deleteFromSecureStore(SECURE_STORE_CRDS_KEY);

              case 17:
                _context22.next = 19;
                return this.rootStore.reloadApp({
                  disableAutoLogin: true
                });

              case 19:
                _context22.next = 23;
                break;

              case 21:
                _context22.prev = 21;
                _context22.t0 = _context22["catch"](3);

              case 23:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this, [[3, 21]]);
      }));

      function logout(_x9) {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                // Placeholder
                this.userProfile = null;
                this.sessionDetails = null;
                this.profileResponse = null;
                this.isAuthenticated = null;
                this.loginModal.reset();
                return _context23.abrupt("return", Promise.resolve());

              case 6:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "refreshSession",
    value: function () {
      var _refreshSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
        var credentials, username, password, socialMediaType, loginModel;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return this.getSavedCredentials();

              case 2:
                credentials = _context25.sent;

                if (!credentials) {
                  _context25.next = 18;
                  break;
                }

                username = credentials.username, password = credentials.password, socialMediaType = credentials.socialMediaType;
                loginModel = this.loginModal;
                loginModel.promptBiometricAuth = false;

                if (!socialMediaType) {
                  _context25.next = 13;
                  break;
                }

                loginModel.email = username;
                loginModel.socialUID = password;
                return _context25.abrupt("return", this.socialLogin());

              case 13:
                loginModel.email = username;
                loginModel.password = password;
                return _context25.abrupt("return", this.loginAndGetUserProfile());

              case 16:
                _context25.next = 19;
                break;

              case 18:
                throw Errors.NO_SAVED_CREDENTIALS;

              case 19:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function refreshSession() {
        return _refreshSession.apply(this, arguments);
      }

      return refreshSession;
    }()
  }, {
    key: "recordLoginFailureEvent",
    value: function () {
      var _recordLoginFailureEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        var currentTimeStamp, _yield$handle, _yield$handle2, err, loginFailureAttemptsStr, loginFailureAttempts;

        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                currentTimeStamp = Date.now();
                _context26.next = 3;
                return handle(this.rootStore.platformUtil.getFromSecureStore("LOGIN_FAILURE_ATTEMPTS"));

              case 3:
                _yield$handle = _context26.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                err = _yield$handle2[0];
                loginFailureAttemptsStr = _yield$handle2[1];
                loginFailureAttempts = !err && loginFailureAttemptsStr ? convertFromString(loginFailureAttemptsStr) : [];

                if (loginFailureAttempts && loginFailureAttempts.length) {
                  loginFailureAttempts.push(currentTimeStamp);
                } else {
                  loginFailureAttempts = [currentTimeStamp];
                }

                _context26.next = 11;
                return handle(this.rootStore.platformUtil.saveInSecureStore("LOGIN_FAILURE_ATTEMPTS", JSON.stringify(loginFailureAttempts)));

              case 11:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function recordLoginFailureEvent() {
        return _recordLoginFailureEvent.apply(this, arguments);
      }

      return recordLoginFailureEvent;
    }()
  }, {
    key: "canPerformLogin",
    value: function () {
      var _canPerformLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        var currentTimeStamp, _yield$handle3, _yield$handle4, err, loginFailureAttemptsStr, loginFailureAttempts, failedInLast10Min, failedIn10to20Min, failedInLast20Min;

        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                currentTimeStamp = Date.now();

                if (!(this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB)) {
                  _context27.next = 3;
                  break;
                }

                return _context27.abrupt("return", true);

              case 3:
                _context27.next = 5;
                return handle(this.rootStore.platformUtil.getFromSecureStore("LOGIN_FAILURE_ATTEMPTS"));

              case 5:
                _yield$handle3 = _context27.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                err = _yield$handle4[0];
                loginFailureAttemptsStr = _yield$handle4[1];
                loginFailureAttempts = !err && loginFailureAttemptsStr ? convertFromString(loginFailureAttemptsStr) : [];

                if (!(loginFailureAttempts && loginFailureAttempts.length)) {
                  _context27.next = 20;
                  break;
                }

                failedInLast10Min = [];
                failedIn10to20Min = [];
                loginFailureAttempts.forEach(function (failureTs) {
                  var diff = currentTimeStamp - failureTs;

                  if (diff <= 10 * 60 * 1000) {
                    failedInLast10Min.push(failureTs);
                  } else if (diff <= 20 * 60 * 1000) {
                    failedIn10to20Min.push(failureTs);
                  } else {
                    console.log("========= Greater than 20 min");
                  }
                });
                failedInLast20Min = [].concat(failedInLast10Min, failedIn10to20Min);
                _context27.next = 17;
                return handle(this.rootStore.platformUtil.saveInSecureStore("LOGIN_FAILURE_ATTEMPTS", JSON.stringify(failedInLast20Min)));

              case 17:
                return _context27.abrupt("return", !(failedInLast20Min.length >= 10 || failedInLast10Min.length >= 5));

              case 20:
                return _context27.abrupt("return", true);

              case 21:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function canPerformLogin() {
        return _canPerformLogin.apply(this, arguments);
      }

      return canPerformLogin;
    }()
  }, {
    key: "attemptLoginWithSavedCredentials",
    value: function () {
      var _attemptLoginWithSavedCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
        var credentials, username, password, socialMediaType;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return this.getSavedCredentials();

              case 2:
                credentials = _context28.sent;

                if (!(credentials && !this.loginModal.disableAutoLogin)) {
                  _context28.next = 14;
                  break;
                }

                username = credentials.username, password = credentials.password, socialMediaType = credentials.socialMediaType;
                _context28.next = 7;
                return handle(DPServices.User.logout());

              case 7:
                if (!socialMediaType) {
                  _context28.next = 12;
                  break;
                }

                _context28.next = 10;
                return handle(DPServices.User.socialLogin(password, username));

              case 10:
                _context28.next = 14;
                break;

              case 12:
                _context28.next = 14;
                return handle(DPServices.User.login(username, password));

              case 14:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function attemptLoginWithSavedCredentials() {
        return _attemptLoginWithSavedCredentials.apply(this, arguments);
      }

      return attemptLoginWithSavedCredentials;
    }()
  }, {
    key: "loginAndGetUserProfile",
    value: function () {
      var _loginAndGetUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
        var _this15 = this;

        var currentTimeStamp, isExpired, userProfile, canPerformLogin, jwtToken, _yield$handle5, _yield$handle6, userProfileErr, userProfileResp;

        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                currentTimeStamp = Date.now();
                isExpired = currentTimeStamp - DPServices.User.lastSessionDetailTimeStamp > 1000 * 60 * 20;
                userProfile = null;

                if (!(!this.isLoggedIn || isExpired)) {
                  _context29.next = 28;
                  break;
                }

                _context29.next = 6;
                return this.canPerformLogin();

              case 6:
                canPerformLogin = _context29.sent;

                if (canPerformLogin) {
                  _context29.next = 9;
                  break;
                }

                throw Errors.LOGIN_FRAUD_ERROR;

              case 9:
                _context29.next = 11;
                return this.ensureAuth();

              case 11:
                jwtToken = _context29.sent;
                _context29.next = 14;
                return handle(DPServices.User.loginAndGetUserProfile(this.loginModal.email.toLowerCase(), this.loginModal.password, false, jwtToken));

              case 14:
                _yield$handle5 = _context29.sent;
                _yield$handle6 = _slicedToArray(_yield$handle5, 2);
                userProfileErr = _yield$handle6[0];
                userProfileResp = _yield$handle6[1];

                if (!userProfileErr) {
                  _context29.next = 24;
                  break;
                }

                _context29.next = 21;
                return this.recordLoginFailureEvent();

              case 21:
                throw userProfileErr;

              case 24:
                userProfile = userProfileResp;

              case 25:
                this.saveCredentials(this.loginModal.email.toLowerCase(), this.loginModal.password, null);
                _context29.next = 29;
                break;

              case 28:
                userProfile = this.userProfile;

              case 29:
                if (userProfile) {
                  this.cacheUserProfile(userProfile);
                  this.postLogin(userProfile);
                } else {
                  runInAction(function () {
                    _this15.loginModal.disableAutoLogin = false;
                    _this15.isAuthenticated = true;
                  });
                }

              case 30:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function loginAndGetUserProfile() {
        return _loginAndGetUserProfile.apply(this, arguments);
      }

      return loginAndGetUserProfile;
    }()
  }, {
    key: "accountCreationEvent",
    value: function () {
      var _accountCreationEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(zipCode, state, country, birthYear, restId, restaurantNum) {
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                this.analyticsModel.dispatchOrderConfirmationAccCreat(zipCode, state, country, birthYear, restId, restaurantNum);

              case 1:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function accountCreationEvent(_x10, _x11, _x12, _x13, _x14, _x15) {
        return _accountCreationEvent.apply(this, arguments);
      }

      return accountCreationEvent;
    }()
  }, {
    key: "signUpAndGetUserProfile",
    value: function () {
      var _signUpAndGetUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
        var _signUpModel$socialLi,
            _signUpModel$socialLi2,
            _signUpModel$socialLi3,
            _this16 = this;

        var signUpModel, dobData, dobDate, dobMonth, dobYear, payload, jwtToken, _yield$handle7, _yield$handle8, error, userProfile, errorDescription;

        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                signUpModel = this.signUpModel;
                dobData = signUpModel.dob.split("/");
                dobDate = dobData[0];
                dobMonth = dobData[1];
                dobYear = dobData[2];
                payload = {
                  email: signUpModel.email.toLowerCase(),
                  password: signUpModel.password,
                  firstName: signUpModel.firstName,
                  lastName: signUpModel.lastName,
                  phone: signUpModel.phoneNumber,
                  restaurantAddressType: "Primary",
                  restaurantCity: signUpModel.restaurantDetails.restaurantCity,
                  restaurantState: signUpModel.restaurantDetails.restaurantState,
                  restaurantZip: signUpModel.restaurantDetails.restaurantZipCode,
                  restaurantAddressLine1: signUpModel.restaurantDetails.restaurantAddressLineOne,
                  restaurantAddressLine2: signUpModel.restaurantDetails.restaurantAddressLineTwo,
                  restaurantCountry: signUpModel.restaurantDetails.restaurantCountry,
                  guestType: "registered",
                  preferredRestaurantId: signUpModel.restaurantDetails.restaurantId,
                  dobDay: dobDate,
                  dobMonth: dobMonth,
                  dobYear: dobYear,
                  primaryEmailOptin: signUpModel.subscribeToOffers ? "P" : "",
                  socialEmail: (_signUpModel$socialLi = signUpModel.socialLinkData) === null || _signUpModel$socialLi === void 0 ? void 0 : _signUpModel$socialLi.email,
                  socialMediaType: (_signUpModel$socialLi2 = signUpModel.socialLinkData) === null || _signUpModel$socialLi2 === void 0 ? void 0 : _signUpModel$socialLi2.mediaType,
                  socialUID: (_signUpModel$socialLi3 = signUpModel.socialLinkData) === null || _signUpModel$socialLi3 === void 0 ? void 0 : _signUpModel$socialLi3.socialUID
                };
                this.accountCreationEvent(signUpModel.restaurantDetails.restaurantZipCode.substring(0, 5), signUpModel.restaurantDetails.restaurantState, "US", dobYear === null || dobYear === void 0 ? void 0 : dobYear.toString(), signUpModel.restaurantDetails.restaurantId, signUpModel.restaurantDetails.restaurantNum);
                _context31.next = 9;
                return this.ensureAuth();

              case 9:
                jwtToken = _context31.sent;
                _context31.next = 12;
                return handle(DPServices.User.signUpAndGetUserProfile(payload, jwtToken));

              case 12:
                _yield$handle7 = _context31.sent;
                _yield$handle8 = _slicedToArray(_yield$handle7, 2);
                error = _yield$handle8[0];
                userProfile = _yield$handle8[1];

                if (!error) {
                  _context31.next = 19;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error, {
                  faultCode: "userAlreadyExists",
                  faultCodeDescriptionOverride: "A user already exists with the login ".concat(signUpModel.email)
                }) || Errors.CREATE_ACCOUNT_FAILURE;
                throw errorDescription;

              case 19:
                this.saveCredentials(signUpModel.email.toLowerCase(), signUpModel.password, null);
                signUpModel.resetValues();

                if (userProfile) {
                  this.cacheUserProfile(userProfile);
                  this.postLogin(userProfile);
                } else {
                  runInAction(function () {
                    _this16.isAuthenticated = true;
                    _this16.loginModal.disableAutoLogin = false;
                    _this16.loginModal.promptBiometricAuth = false;
                  });
                }

              case 22:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function signUpAndGetUserProfile() {
        return _signUpAndGetUserProfile.apply(this, arguments);
      }

      return signUpAndGetUserProfile;
    }()
  }, {
    key: "getFromLegacyStorage",
    value: function () {
      var _getFromLegacyStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(appleSignInRef) {
        var oldEncrytedEmail, oldEmail, oldEncrytedFirstName, oldFirstName, oldEncrytedLastName, oldLastName;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return this.rootStore.platformUtil.getFromOldKeyChain("userEmailSiwa");

              case 2:
                oldEncrytedEmail = _context32.sent;
                console.log("+++++++Encrypted Email" + oldEncrytedEmail);

                if (!oldEncrytedEmail) {
                  _context32.next = 10;
                  break;
                }

                _context32.next = 7;
                return DPServices.User.decryptLegacyEncryptedData(oldEncrytedEmail);

              case 7:
                oldEmail = _context32.sent;
                console.log("-------Decrypted email=" + oldEmail);
                appleSignInRef.email = oldEmail;

              case 10:
                _context32.next = 12;
                return this.rootStore.platformUtil.getFromOldKeyChain("firstNameSiwa");

              case 12:
                oldEncrytedFirstName = _context32.sent;
                console.log("+++++++Encrypted FirstName" + oldEncrytedFirstName);

                if (!oldEncrytedFirstName) {
                  _context32.next = 20;
                  break;
                }

                _context32.next = 17;
                return DPServices.User.decryptLegacyEncryptedData(oldEncrytedFirstName);

              case 17:
                oldFirstName = _context32.sent;
                console.log("-------Decrypted FirstName=" + oldFirstName);
                appleSignInRef.fullName.givenName = oldFirstName;

              case 20:
                _context32.next = 22;
                return this.rootStore.platformUtil.getFromOldKeyChain("lastNameSiwa");

              case 22:
                oldEncrytedLastName = _context32.sent;
                console.log("+++++++Encrypted LastName" + oldEncrytedLastName);

                if (!oldEncrytedLastName) {
                  _context32.next = 30;
                  break;
                }

                _context32.next = 27;
                return DPServices.User.decryptLegacyEncryptedData(oldEncrytedLastName);

              case 27:
                oldLastName = _context32.sent;
                console.log("-------Decrypted LastName=" + oldLastName);
                appleSignInRef.fullName.familyName = oldLastName;

              case 30:
                return _context32.abrupt("return", appleSignInRef);

              case 31:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function getFromLegacyStorage(_x16) {
        return _getFromLegacyStorage.apply(this, arguments);
      }

      return getFromLegacyStorage;
    }()
  }, {
    key: "performAppleSignIn",
    value: function () {
      var _performAppleSignIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(appleSignInRef) {
        var _this17 = this;

        var _yield$handle9, _yield$handle10, err, savedAppleSignInCredsStr;

        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                if (!appleSignInRef.email) {
                  _context33.next = 5;
                  break;
                }

                _context33.next = 3;
                return handle(this.rootStore.platformUtil.saveInSecureStore("APPLE_SIGN_IN_CREDENTIALS", JSON.stringify(appleSignInRef)));

              case 3:
                _context33.next = 22;
                break;

              case 5:
                _context33.next = 7;
                return handle(this.rootStore.platformUtil.getFromSecureStore("APPLE_SIGN_IN_CREDENTIALS"));

              case 7:
                _yield$handle9 = _context33.sent;
                _yield$handle10 = _slicedToArray(_yield$handle9, 2);
                err = _yield$handle10[0];
                savedAppleSignInCredsStr = _yield$handle10[1];

                if (!savedAppleSignInCredsStr) {
                  _context33.next = 15;
                  break;
                }

                appleSignInRef = JSON.parse(savedAppleSignInCredsStr);
                _context33.next = 22;
                break;

              case 15:
                _context33.next = 17;
                return this.getFromLegacyStorage(appleSignInRef);

              case 17:
                appleSignInRef = _context33.sent;
                console.log(" after legacy hydration: " + JSON.stringify(appleSignInRef));

                if (!(appleSignInRef.email && appleSignInRef.fullName.givenName && appleSignInRef.fullName.familyName)) {
                  _context33.next = 22;
                  break;
                }

                _context33.next = 22;
                return handle(this.rootStore.platformUtil.saveInSecureStore("APPLE_SIGN_IN_CREDENTIALS", JSON.stringify(appleSignInRef)));

              case 22:
                console.log("*** inside performAppleSigin appleSignInRef=" + JSON.stringify(appleSignInRef));
                this.loginModal.socialUID = appleSignInRef.user;
                this.loginModal.email = appleSignInRef.email;
                this.loginModal.socialMediaType = UserTypes.SocialMediaType.APPLE;
                runInAction(function () {
                  _this17.loginModal.socialProfile = {
                    id: appleSignInRef.user,
                    type: UserTypes.SocialMediaType.APPLE,
                    email: appleSignInRef.email,
                    firstName: appleSignInRef.fullName.givenName,
                    lastName: appleSignInRef.fullName.familyName,
                    picture: {
                      url: null
                    }
                  };
                });
                _context33.next = 29;
                return this.socialLogin();

              case 29:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function performAppleSignIn(_x17) {
        return _performAppleSignIn.apply(this, arguments);
      }

      return performAppleSignIn;
    }()
  }, {
    key: "performGoogleSignIn",
    value: function () {
      var _performGoogleSignIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(accessToken) {
        var _this18 = this;

        var googleUserInfo;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _context34.next = 2;
                return DPServices.User.getGoogleUserInfo(accessToken);

              case 2:
                googleUserInfo = _context34.sent;
                this.loginModal.socialUID = googleUserInfo.id;
                this.loginModal.email = googleUserInfo.email;
                this.loginModal.socialMediaType = UserTypes.SocialMediaType.GOOGLEPLUS;
                runInAction(function () {
                  _this18.loginModal.socialProfile = googleUserInfo;
                });
                _context34.next = 9;
                return this.socialLogin();

              case 9:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function performGoogleSignIn(_x18) {
        return _performGoogleSignIn.apply(this, arguments);
      }

      return performGoogleSignIn;
    }()
  }, {
    key: "performFacebookSignIn",
    value: function () {
      var _performFacebookSignIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(accessToken) {
        var _this19 = this;

        var facebookUserInfo;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.next = 2;
                return DPServices.User.getFacebookUserInfo(accessToken);

              case 2:
                facebookUserInfo = _context35.sent;
                this.loginModal.socialUID = facebookUserInfo.id;
                this.loginModal.email = facebookUserInfo.email;
                this.loginModal.socialMediaType = UserTypes.SocialMediaType.FACEBOOK;
                runInAction(function () {
                  _this19.loginModal.socialProfile = facebookUserInfo;
                });
                _context35.next = 9;
                return this.socialLogin();

              case 9:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function performFacebookSignIn(_x19) {
        return _performFacebookSignIn.apply(this, arguments);
      }

      return performFacebookSignIn;
    }()
  }, {
    key: "setCreateAccountFields",
    value: function setCreateAccountFields() {
      var _this$loginModal$soci, _this$loginModal$soci2;

      this.signUpModel.firstName = (_this$loginModal$soci = this.loginModal.socialProfile.firstName) === null || _this$loginModal$soci === void 0 ? void 0 : _this$loginModal$soci.trim();
      this.signUpModel.lastName = (_this$loginModal$soci2 = this.loginModal.socialProfile.lastName) === null || _this$loginModal$soci2 === void 0 ? void 0 : _this$loginModal$soci2.trim();
      this.signUpModel.email = this.loginModal.socialProfile.email;
      this.signUpModel.socialLinkData = {
        email: this.loginModal.socialProfile.email,
        mediaType: this.loginModal.socialMediaType,
        socialUID: this.loginModal.socialUID
      };
    }
  }, {
    key: "socialLogin",
    value: function () {
      var _socialLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
        var _this20 = this;

        var currentTimeStamp, isExpired, userProfile, _this$loginModal$emai, _this$loginModal$emai2, jwtToken, _yield$handle11, _yield$handle12, err, usrProfile, _response, _response$data;

        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                currentTimeStamp = Date.now();
                isExpired = currentTimeStamp - DPServices.User.lastSessionDetailTimeStamp > 1000 * 60 * 20;
                userProfile = null;

                if (!(!this.isLoggedIn || isExpired)) {
                  _context36.next = 22;
                  break;
                }

                console.log("this.loginModal.socialUID=" + this.loginModal.socialUID + ", this.loginModal.email?.toLowerCase()=" + ((_this$loginModal$emai = this.loginModal.email) === null || _this$loginModal$emai === void 0 ? void 0 : _this$loginModal$emai.toLowerCase()));
                _context36.next = 7;
                return this.ensureAuth();

              case 7:
                jwtToken = _context36.sent;
                _context36.next = 10;
                return handle(DPServices.User.socialLoginAndGetUserProfile(this.loginModal.socialUID, (_this$loginModal$emai2 = this.loginModal.email) === null || _this$loginModal$emai2 === void 0 ? void 0 : _this$loginModal$emai2.toLowerCase(), false, jwtToken));

              case 10:
                _yield$handle11 = _context36.sent;
                _yield$handle12 = _slicedToArray(_yield$handle11, 2);
                err = _yield$handle12[0];
                usrProfile = _yield$handle12[1];

                if (!err) {
                  _context36.next = 17;
                  break;
                }

                if ((err === null || err === void 0 ? void 0 : (_response = err.response) === null || _response === void 0 ? void 0 : (_response$data = _response.data) === null || _response$data === void 0 ? void 0 : _response$data.profileStatus) === "The account is not registered") {
                  this.setCreateAccountFields();
                }

                throw err;

              case 17:
                userProfile = usrProfile;
                _context36.next = 20;
                return this.saveCredentials(this.loginModal.email, this.loginModal.socialUID, this.loginModal.socialMediaType);

              case 20:
                _context36.next = 23;
                break;

              case 22:
                userProfile = this.userProfile;

              case 23:
                if (userProfile) {
                  this.cacheUserProfile(userProfile);
                  this.postLogin(userProfile);
                } else {
                  runInAction(function () {
                    _this20.loginModal.disableAutoLogin = false;
                    _this20.isAuthenticated = true;
                  });
                }

              case 24:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function socialLogin() {
        return _socialLogin.apply(this, arguments);
      }

      return socialLogin;
    }()
  }, {
    key: "postLogin",
    value: function () {
      var _postLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(userProfile) {
        var _this$loginModal,
            _this$loginModal$user,
            _this21 = this;

        var accessToken, sessionDetails;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                this.loginModal.promptBiometricAuth = false; // Get access token if user logged in

                _context37.next = 3;
                return this.getTokenSilentIfLoggedIn();

              case 3:
                accessToken = _context37.sent;
                _context37.next = 6;
                return DPServices.User.getSessionDetails({
                  jwtToken: accessToken
                });

              case 6:
                sessionDetails = _context37.sent;

                if (userProfile.login !== ((_this$loginModal = this.loginModal) === null || _this$loginModal === void 0 ? void 0 : (_this$loginModal$user = _this$loginModal.userSelectedProfilePicture) === null || _this$loginModal$user === void 0 ? void 0 : _this$loginModal$user.email)) {
                  runInAction(function () {
                    _this21.loginModal.userSelectedProfilePicture = null;
                  });
                  this.analyticsModel.setSessionDetails(sessionDetails);
                }

                runInAction(function () {
                  _this21.sessionDetails = sessionDetails;
                  _this21.userProfile = userProfile;
                  _this21.isAuthenticated = true;
                  _this21.loginModal.disableAutoLogin = false;
                });

              case 9:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function postLogin(_x20) {
        return _postLogin.apply(this, arguments);
      }

      return postLogin;
    }()
  }, {
    key: "_performSocialLinkandLogin",
    value: function () {
      var _performSocialLinkandLogin2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
        var _this22 = this;

        var email, password, savedCreds, jwtToken, _yield$handle13, _yield$handle14, userProfileErr, userProfileResp, errorDescription, _yield$handle15, _yield$handle16, errorResponse, profileResponse, _errorDescription;

        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                email = this.loginModal.email.toLowerCase();
                password = this.loginModal.password;
                _context38.next = 4;
                return this.getSavedCredentials();

              case 4:
                savedCreds = _context38.sent;
                console.log("*** saved Creds preform social link====>", savedCreds);

                if (savedCreds && savedCreds.socialMediaType === "apple") {
                  email = savedCreds === null || savedCreds === void 0 ? void 0 : savedCreds.username;
                  password = savedCreds === null || savedCreds === void 0 ? void 0 : savedCreds.password;
                }

                _context38.next = 9;
                return this.ensureAuth();

              case 9:
                jwtToken = _context38.sent;
                _context38.next = 12;
                return handle(DPServices.User.loginAndGetUserProfile(email, password, false, jwtToken));

              case 12:
                _yield$handle13 = _context38.sent;
                _yield$handle14 = _slicedToArray(_yield$handle13, 2);
                userProfileErr = _yield$handle14[0];
                userProfileResp = _yield$handle14[1];

                if (!userProfileErr) {
                  _context38.next = 19;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(userProfileErr) || Errors.SOCIAL_LINK_FAILED;
                throw errorDescription;

              case 19:
                _context38.next = 21;
                return handle(DPServices.User.performSocialLink(this.loginModal.email, this.loginModal.socialUID, this.loginModal.socialMediaType));

              case 21:
                _yield$handle15 = _context38.sent;
                _yield$handle16 = _slicedToArray(_yield$handle15, 2);
                errorResponse = _yield$handle16[0];
                profileResponse = _yield$handle16[1];

                if (!errorResponse) {
                  _context38.next = 29;
                  break;
                }

                runInAction(function () {
                  _this22.loginModal.socialProfile = null;
                });
                _errorDescription = DPServices.Common.checkAndGetErrorDescription(errorResponse) || Errors.SOCIAL_LINK_FAILED;
                throw _errorDescription;

              case 29:
                if (!(profileResponse !== null && profileResponse !== void 0 && profileResponse.response)) {
                  _context38.next = 35;
                  break;
                }

                _context38.next = 32;
                return this.saveCredentials(this.loginModal.email, this.loginModal.socialUID, this.loginModal.socialMediaType);

              case 32:
                if (userProfileResp) {
                  this.cacheUserProfile(userProfileResp);
                  this.postLogin(userProfileResp);
                } else {
                  runInAction(function () {
                    _this22.loginModal.disableAutoLogin = false;
                    _this22.isAuthenticated = true;
                  });
                }

                _context38.next = 36;
                break;

              case 35:
                runInAction(function () {
                  _this22.loginModal.socialProfile = null;
                });

              case 36:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function _performSocialLinkandLogin() {
        return _performSocialLinkandLogin2.apply(this, arguments);
      }

      return _performSocialLinkandLogin;
    }()
  }, {
    key: "socialLink",
    value: function () {
      var _socialLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
        var clearSavedCredentials;
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.prev = 0;
                _context39.next = 3;
                return this._performSocialLinkandLogin();

              case 3:
                _context39.next = 13;
                break;

              case 5:
                _context39.prev = 5;
                _context39.t0 = _context39["catch"](0);
                clearSavedCredentials = !(this.deviceAuth.hasHardWare && this.deviceAuth.isEnrolled);

                if (!clearSavedCredentials) {
                  _context39.next = 11;
                  break;
                }

                _context39.next = 11;
                return this.rootStore.platformUtil.deleteFromSecureStore(SECURE_STORE_CRDS_KEY);

              case 11:
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context39.t0.message, null, {
                  okBtnText: "Okay",
                  okBtnOnClick: function okBtnOnClick() {
                    handle(DPServices.User.logout());
                  }
                });
                throw _context39.t0;

              case 13:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this, [[0, 5]]);
      }));

      function socialLink() {
        return _socialLink.apply(this, arguments);
      }

      return socialLink;
    }()
  }, {
    key: "navigateToSocialRegistration",
    value: function navigateToSocialRegistration(user) {
      var isMobileSite = this.rootStore.isMobile;
      var redirectUrl = "/customer-service/social-registration?";

      if (isMobileSite) {
        redirectUrl = redirectUrl + "regSocialUID=" + user._profile.id + "&regSocialFirstName=" + user._profile.firstName + "&regSocialLastName=" + user._profile.lastName + "&regSocialEmailId=" + user._profile.email;
      } else {
        redirectUrl = redirectUrl + "socialUid=" + user._profile.id + "&socialFirstName=" + user._profile.firstName + "&socialLastName=" + user._profile.lastName + "&socialEmailId=" + user._profile.email;
      }

      this.rootStore.refreshInProgress = true;
      this.rootStore.platformUtil.redirectToURL(redirectUrl);
    }
  }, {
    key: "getSavedCredentials",
    value: function () {
      var _getSavedCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40() {
        var isSecureStoreAvailable, credentialsJsonStr;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                _context40.next = 2;
                return this.rootStore.platformUtil.isSecureStoreAvailable();

              case 2:
                isSecureStoreAvailable = _context40.sent;

                if (!isSecureStoreAvailable) {
                  _context40.next = 14;
                  break;
                }

                _context40.next = 6;
                return this.rootStore.platformUtil.getFromSecureStore(SECURE_STORE_CRDS_KEY);

              case 6:
                credentialsJsonStr = _context40.sent;

                if (!credentialsJsonStr) {
                  _context40.next = 11;
                  break;
                }

                return _context40.abrupt("return", JSON.parse(credentialsJsonStr));

              case 11:
                return _context40.abrupt("return", null);

              case 12:
                _context40.next = 15;
                break;

              case 14:
                return _context40.abrupt("return", null);

              case 15:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function getSavedCredentials() {
        return _getSavedCredentials.apply(this, arguments);
      }

      return getSavedCredentials;
    }()
  }, {
    key: "saveCredentials",
    value: function saveCredentials(username, password, socialMediaType) {
      var credentials = {
        password: password,
        username: username,
        socialMediaType: socialMediaType
      };

      if (!socialMediaType) {
        delete credentials.socialMediaType;
      }

      return this.rootStore.platformUtil.saveInSecureStore(SECURE_STORE_CRDS_KEY, JSON.stringify(credentials));
    }
  }, {
    key: "whenAppActive",
    value: function () {
      var _whenAppActive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
        var _this$rootStore, _this$rootStore$joinW;

        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                _context41.next = 2;
                return Promise.all([this.determineDeviceCapabilities(), (_this$rootStore = this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$joinW = _this$rootStore.joinWaitlist) === null || _this$rootStore$joinW === void 0 ? void 0 : _this$rootStore$joinW.loadAndSetWaitlistId()]);

              case 2:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));

      function whenAppActive() {
        return _whenAppActive.apply(this, arguments);
      }

      return whenAppActive;
    }()
  }, {
    key: "updateName",
    value: function () {
      var _updateName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42() {
        var _this23 = this;

        var _this$userProfileMode, _this$userProfile, _this$userProfileMode2, _this$userProfile2, _this$userProfile3, _this$userProfile4, payload, jwtToken, response, profile, error, isWeb;

        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                _context42.prev = 0;
                payload = {
                  firstName: ((_this$userProfileMode = this.userProfileModel) === null || _this$userProfileMode === void 0 ? void 0 : _this$userProfileMode.updatedUserFirstName) || ((_this$userProfile = this.userProfile) === null || _this$userProfile === void 0 ? void 0 : _this$userProfile.firstName),
                  lastName: ((_this$userProfileMode2 = this.userProfileModel) === null || _this$userProfileMode2 === void 0 ? void 0 : _this$userProfileMode2.userLastName) || ((_this$userProfile2 = this.userProfile) === null || _this$userProfile2 === void 0 ? void 0 : _this$userProfile2.lastName),
                  suffix: (_this$userProfile3 = this.userProfile) === null || _this$userProfile3 === void 0 ? void 0 : _this$userProfile3.suffix,
                  salutation: (_this$userProfile4 = this.userProfile) === null || _this$userProfile4 === void 0 ? void 0 : _this$userProfile4.salutation
                };
                _context42.next = 4;
                return this.ensureAuth();

              case 4:
                jwtToken = _context42.sent;
                _context42.next = 7;
                return DPServices.User.updateProfileName({
                  jwtToken: jwtToken,
                  payload: payload
                })["catch"](function (err) {
                  throw err;
                });

              case 7:
                response = _context42.sent;

                if (response) {
                  profile = response;
                  runInAction(function () {
                    _this23.userProfile = profile;
                  });
                  this.cacheUserProfile(profile);
                }

                this.userProfileModel.resetValues();
                _context42.next = 18;
                break;

              case 12:
                _context42.prev = 12;
                _context42.t0 = _context42["catch"](0);
                error = DPServices.Common.handleUIErrorAndOverride(_context42.t0, {
                  title: ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG,
                  message: Errors.UPDATE_FIRST_NAME_FAILED.message
                });
                isWeb = this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB;
                this.rootStore.appMessages.showError(error.title, error.message, null, {
                  okBtnText: isWeb ? "Okay" : "Home",
                  okBtnOnClick: function okBtnOnClick() {
                    if (isWeb) {
                      _this23.userProfileModel.resetModals();
                    } else {
                      _this23.rootStore.reloadApp();
                    }
                  }
                });
                throw _context42.t0;

              case 18:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this, [[0, 12]]);
      }));

      function updateName() {
        return _updateName.apply(this, arguments);
      }

      return updateName;
    }()
  }, {
    key: "addPhoneNumber",
    value: function () {
      var _addPhoneNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43() {
        var _this24 = this;

        var _this$userProfile5, _this$userProfile5$de, _this$userProfileMode3, _this$userProfile6, _this$userProfile6$de, payload, jwtToken, response, profile, error, isWeb;

        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                _context43.prev = 0;
                payload = {
                  phoneextension: (_this$userProfile5 = this.userProfile) === null || _this$userProfile5 === void 0 ? void 0 : (_this$userProfile5$de = _this$userProfile5.defaultPhone) === null || _this$userProfile5$de === void 0 ? void 0 : _this$userProfile5$de.phoneExt,
                  phonenumber: (_this$userProfileMode3 = this.userProfileModel) === null || _this$userProfileMode3 === void 0 ? void 0 : _this$userProfileMode3.updatedUserMobileNumber,
                  phoneType: ((_this$userProfile6 = this.userProfile) === null || _this$userProfile6 === void 0 ? void 0 : (_this$userProfile6$de = _this$userProfile6.defaultPhone) === null || _this$userProfile6$de === void 0 ? void 0 : _this$userProfile6$de.phoneType) || "Mobile",
                  "default": "true"
                };
                _context43.next = 4;
                return this.ensureAuth();

              case 4:
                jwtToken = _context43.sent;
                _context43.next = 7;
                return DPServices.User.addPhoneNumber({
                  jwtToken: jwtToken,
                  payload: payload
                })["catch"](function (err) {
                  throw err;
                });

              case 7:
                response = _context43.sent;
                profile = response;
                runInAction(function () {
                  _this24.userProfile = profile;
                });
                this.cacheUserProfile(profile);
                _context43.next = 19;
                break;

              case 13:
                _context43.prev = 13;
                _context43.t0 = _context43["catch"](0);
                error = DPServices.Common.handleUIErrorAndOverride(_context43.t0, {
                  title: ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG,
                  message: Errors.UPDATE_PHONE_NUMBER_FAILED.message
                });
                isWeb = this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB;
                this.rootStore.appMessages.showError(error.title, error.message, null, {
                  okBtnText: isWeb ? "Okay" : "Home",
                  okBtnOnClick: function okBtnOnClick() {
                    if (isWeb) {
                      _this24.userProfileModel.resetModals();
                    } else {
                      _this24.rootStore.reloadApp();
                    }
                  }
                });
                throw _context43.t0;

              case 19:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this, [[0, 13]]);
      }));

      function addPhoneNumber() {
        return _addPhoneNumber.apply(this, arguments);
      }

      return addPhoneNumber;
    }()
  }, {
    key: "updatePhoneNumber",
    value: function () {
      var _updatePhoneNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44() {
        var _this25 = this;

        var _this$userProfile7, _this$userProfile7$de, _this$userProfile8, _this$userProfile8$de, _this$userProfileMode4, _this$userProfile9, _this$userProfile9$de, payload, jwtToken, repsonse, profile, error, isWeb;

        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                _context44.prev = 0;
                payload = {
                  phoneId: (_this$userProfile7 = this.userProfile) === null || _this$userProfile7 === void 0 ? void 0 : (_this$userProfile7$de = _this$userProfile7.defaultPhone) === null || _this$userProfile7$de === void 0 ? void 0 : _this$userProfile7$de.phoneId,
                  phoneextension: (_this$userProfile8 = this.userProfile) === null || _this$userProfile8 === void 0 ? void 0 : (_this$userProfile8$de = _this$userProfile8.defaultPhone) === null || _this$userProfile8$de === void 0 ? void 0 : _this$userProfile8$de.phoneExt,
                  phonenumber: (_this$userProfileMode4 = this.userProfileModel) === null || _this$userProfileMode4 === void 0 ? void 0 : _this$userProfileMode4.updatedUserMobileNumber,
                  phoneType: ((_this$userProfile9 = this.userProfile) === null || _this$userProfile9 === void 0 ? void 0 : (_this$userProfile9$de = _this$userProfile9.defaultPhone) === null || _this$userProfile9$de === void 0 ? void 0 : _this$userProfile9$de.phoneType) || "Mobile",
                  "default": "true"
                };
                _context44.next = 4;
                return this.ensureAuth();

              case 4:
                jwtToken = _context44.sent;
                _context44.next = 7;
                return DPServices.User.updatePhoneNumber({
                  jwtToken: jwtToken,
                  payload: payload
                })["catch"](function (err) {
                  throw err;
                });

              case 7:
                repsonse = _context44.sent;
                profile = repsonse;
                runInAction(function () {
                  _this25.userProfile = profile;
                });
                this.cacheUserProfile(profile);
                _context44.next = 19;
                break;

              case 13:
                _context44.prev = 13;
                _context44.t0 = _context44["catch"](0);
                error = DPServices.Common.handleUIErrorAndOverride(_context44.t0, {
                  title: ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG,
                  message: Errors.UPDATE_PHONE_NUMBER_FAILED.message
                });
                isWeb = this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB;
                this.rootStore.appMessages.showError(error.title, error.message, null, {
                  okBtnText: isWeb ? "Okay" : "Home",
                  okBtnOnClick: function okBtnOnClick() {
                    if (isWeb) {
                      _this25.userProfileModel.resetModals();
                    } else {
                      _this25.rootStore.reloadApp();
                    }
                  }
                });
                throw _context44.t0;

              case 19:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this, [[0, 13]]);
      }));

      function updatePhoneNumber() {
        return _updatePhoneNumber.apply(this, arguments);
      }

      return updatePhoneNumber;
    }()
  }, {
    key: "updateEmailAddress",
    value: function () {
      var _updateEmailAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45() {
        var _this26 = this;

        var _this$userProfileMode5, _this$userProfileMode6, _this$userProfileMode7, payload, jwtToken, response, profile, error, isWeb;

        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                _context45.prev = 0;
                payload = {
                  confirmemail: (_this$userProfileMode5 = this.userProfileModel) === null || _this$userProfileMode5 === void 0 ? void 0 : _this$userProfileMode5.newUserEmailAddress,
                  email: (_this$userProfileMode6 = this.userProfileModel) === null || _this$userProfileMode6 === void 0 ? void 0 : _this$userProfileMode6.newUserEmailAddress,
                  subscrpTransferStatus: (_this$userProfileMode7 = this.userProfileModel) === null || _this$userProfileMode7 === void 0 ? void 0 : _this$userProfileMode7.subscrpTransferStatus
                };
                _context45.next = 4;
                return this.ensureAuth();

              case 4:
                jwtToken = _context45.sent;
                _context45.next = 7;
                return DPServices.User.updateEmailAddress({
                  jwtToken: jwtToken,
                  payload: payload
                })["catch"](function (err) {
                  throw err;
                });

              case 7:
                response = _context45.sent;
                profile = response;
                runInAction(function () {
                  _this26.userProfile = profile;
                });
                this.cacheUserProfile(profile);
                _context45.next = 19;
                break;

              case 13:
                _context45.prev = 13;
                _context45.t0 = _context45["catch"](0);
                error = DPServices.Common.handleUIErrorAndOverride(_context45.t0, {
                  title: ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG,
                  message: Errors.UPDATE_EMAIL_ADDRESS_FAILED.message
                });
                isWeb = this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB;
                this.rootStore.appMessages.showError(error.title, error.message, null, {
                  okBtnText: isWeb ? "Okay" : "Home",
                  okBtnOnClick: function okBtnOnClick() {
                    if (isWeb) {
                      _this26.userProfileModel.resetModals();
                    } else {
                      _this26.rootStore.reloadApp();
                    }
                  }
                });
                throw _context45.t0;

              case 19:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this, [[0, 13]]);
      }));

      function updateEmailAddress() {
        return _updateEmailAddress.apply(this, arguments);
      }

      return updateEmailAddress;
    }()
  }, {
    key: "updateUserPassword",
    value: function () {
      var _updateUserPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46() {
        var _this27 = this;

        var profileModel, userConfirmPassword, userNewPassword, payload, jwtToken, response, profile, error, isWeb;
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                _context46.prev = 0;
                profileModel = this.userProfileModel;
                userConfirmPassword = profileModel.userConfirmPassword, userNewPassword = profileModel.userNewPassword;
                payload = {
                  confirmPassword: userConfirmPassword,
                  password: userNewPassword
                };
                _context46.next = 6;
                return this.ensureAuth();

              case 6:
                jwtToken = _context46.sent;
                _context46.next = 9;
                return DPServices.User.updatePassword({
                  jwtToken: jwtToken,
                  payload: payload
                })["catch"](function (err) {
                  throw err;
                });

              case 9:
                response = _context46.sent;
                profile = response;
                _context46.next = 13;
                return this.saveCredentials(profile.login, payload.confirmPassword, null);

              case 13:
                runInAction(function () {
                  _this27.userProfile = profile;
                });
                this.cacheUserProfile(profile);
                profileModel.resetValues();
                _context46.next = 24;
                break;

              case 18:
                _context46.prev = 18;
                _context46.t0 = _context46["catch"](0);
                error = DPServices.Common.handleUIErrorAndOverride(_context46.t0, {
                  title: ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG,
                  message: Errors.UPDATE_PASSWORD_FAILED.message
                });
                isWeb = this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB;
                this.rootStore.appMessages.showError(error.title, error.message, null, {
                  okBtnText: isWeb ? "Okay" : "Home",
                  okBtnOnClick: function okBtnOnClick() {
                    if (isWeb) {
                      _this27.userProfileModel.resetModals();
                    } else {
                      _this27.rootStore.reloadApp();
                    }
                  }
                });
                throw _context46.t0;

              case 24:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this, [[0, 18]]);
      }));

      function updateUserPassword() {
        return _updateUserPassword.apply(this, arguments);
      }

      return updateUserPassword;
    }()
  }, {
    key: "updatePrefferedLocation",
    value: function () {
      var _updatePrefferedLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(restaurantNum) {
        var _this28 = this;

        var jwtToken, response, _this$rootStore2, _this$rootStore2$plat, error, isWeb;

        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                _context47.prev = 0;
                _context47.next = 3;
                return this.ensureAuth();

              case 3:
                jwtToken = _context47.sent;
                _context47.next = 6;
                return DPServices.User.updatePreferredLocation({
                  jwtToken: jwtToken,
                  payload: {
                    restaurantNum: restaurantNum,
                    isDefault: true
                  }
                })["catch"](function (err) {
                  throw err;
                });

              case 6:
                response = _context47.sent;

                if (response) {
                  runInAction(function () {
                    _this28.userProfile = response;
                  });
                  this.userProfileModel.isChangeLocationModalOpen = false;
                  (_this$rootStore2 = this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$plat = _this$rootStore2.platformUtil) === null || _this$rootStore2$plat === void 0 ? void 0 : _this$rootStore2$plat.dispatchEvent("AnalyticsEvent", "SetPreferredLocation", {
                    restaurantNum: restaurantNum,
                    isDefault: true
                  });
                }

                _context47.next = 15;
                break;

              case 10:
                _context47.prev = 10;
                _context47.t0 = _context47["catch"](0);
                error = DPServices.Common.handleUIErrorAndOverride(_context47.t0, {
                  title: ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG,
                  message: "Please try again later"
                });
                isWeb = this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB;
                this.rootStore.appMessages.showError(error.title, error.message, null, {
                  okBtnText: isWeb ? "Okay" : "Home",
                  okBtnOnClick: function okBtnOnClick() {
                    if (isWeb) {
                      _this28.userProfileModel.resetModals();
                    } else {
                      _this28.rootStore.reloadApp();
                    }
                  }
                });

              case 15:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this, [[0, 10]]);
      }));

      function updatePrefferedLocation(_x21) {
        return _updatePrefferedLocation.apply(this, arguments);
      }

      return updatePrefferedLocation;
    }()
  }, {
    key: "updateUserDob",
    value: function () {
      var _updateUserDob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48() {
        var _this29 = this;

        var flow,
            _this$userProfileMode8,
            _this$signUpModel,
            scheduledDate,
            date,
            profileModel,
            userDobDay,
            userDobMonth,
            userDobYear,
            payload,
            jwtToken,
            response,
            profile,
            error,
            isWeb,
            _args48 = arguments;

        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                flow = _args48.length > 0 && _args48[0] !== undefined ? _args48[0] : "PROFILE";
                _context48.prev = 1;
                scheduledDate = flow === "PROFILE" ? (_this$userProfileMode8 = this.userProfileModel) === null || _this$userProfileMode8 === void 0 ? void 0 : _this$userProfileMode8.scheduledDOB : (_this$signUpModel = this.signUpModel) === null || _this$signUpModel === void 0 ? void 0 : _this$signUpModel.dob;
                date = new Date(scheduledDate);
                this.userProfileModel.userDobDay = date.getDate() < 10 ? "0".concat(date.getDate()) : date.getDate().toString();
                this.userProfileModel.userDobMonth = date.getMonth() + 1 < 10 ? "0".concat(date.getMonth() + 1) : "".concat(date.getMonth() + 1);
                this.userProfileModel.userDobYear = date.getFullYear().toString();
                profileModel = this.userProfileModel;
                userDobDay = profileModel.userDobDay, userDobMonth = profileModel.userDobMonth, userDobYear = profileModel.userDobYear;
                payload = {
                  dobYear: +userDobYear,
                  dobMonth: +userDobMonth,
                  dobDay: +userDobDay
                };
                _context48.next = 12;
                return this.ensureAuth();

              case 12:
                jwtToken = _context48.sent;
                _context48.next = 15;
                return DPServices.User.updateDob({
                  jwtToken: jwtToken,
                  payload: payload
                })["catch"](function (err) {
                  throw err;
                });

              case 15:
                response = _context48.sent;
                profile = response;
                runInAction(function () {
                  _this29.userProfile = profile;
                });
                this.cacheUserProfile(profile);
                profileModel.resetValues();
                _context48.next = 28;
                break;

              case 22:
                _context48.prev = 22;
                _context48.t0 = _context48["catch"](1);
                error = DPServices.Common.handleUIErrorAndOverride(_context48.t0, {
                  title: ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG,
                  message: Errors.UPDATE_FIRST_NAME_FAILED.message
                });
                isWeb = this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB;
                this.rootStore.appMessages.showError(error.title, error.message, null, {
                  okBtnText: isWeb ? "Okay" : "Home",
                  okBtnOnClick: function okBtnOnClick() {
                    if (isWeb) {
                      _this29.userProfileModel.resetModals();
                    } else {
                      _this29.rootStore.reloadApp();
                    }
                  }
                });
                throw _context48.t0;

              case 28:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this, [[1, 22]]);
      }));

      function updateUserDob() {
        return _updateUserDob.apply(this, arguments);
      }

      return updateUserDob;
    }()
  }, {
    key: "resetPasswordRequest",
    value: function () {
      var _resetPasswordRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49() {
        var _this$userProfileMode9;

        var payload, _yield$handle17, _yield$handle18, error, response, errorDescription;

        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                payload = {
                  login: (_this$userProfileMode9 = this.userProfileModel) === null || _this$userProfileMode9 === void 0 ? void 0 : _this$userProfileMode9.resetPasswordEmailAddress
                };
                _context49.next = 3;
                return handle(DPServices.User.resetPasswordRequest(payload));

              case 3:
                _yield$handle17 = _context49.sent;
                _yield$handle18 = _slicedToArray(_yield$handle17, 2);
                error = _yield$handle18[0];
                response = _yield$handle18[1];

                if (!error) {
                  _context49.next = 10;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.RESET_PASSWORD_FAILED;
                throw errorDescription;

              case 10:
                return _context49.abrupt("return", response);

              case 11:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function resetPasswordRequest() {
        return _resetPasswordRequest.apply(this, arguments);
      }

      return resetPasswordRequest;
    }()
  }, {
    key: "resetPassword",
    value: function () {
      var _resetPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(uid, fptoken) {
        var _this$userProfileMode10, _this$userProfileMode11, _this$userProfileMode12, payload, _yield$handle19, _yield$handle20, err, response, _DPServices$Cart$pars, errObj, faults, haveErrorDescription, userProfile;

        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                _context50.prev = 0;
                payload = {
                  login: (_this$userProfileMode10 = this.userProfileModel) === null || _this$userProfileMode10 === void 0 ? void 0 : _this$userProfileMode10.resetPasswordEmailAddress,
                  password: (_this$userProfileMode11 = this.userProfileModel) === null || _this$userProfileMode11 === void 0 ? void 0 : _this$userProfileMode11.resetPasswordNewPassword,
                  confirmPassword: (_this$userProfileMode12 = this.userProfileModel) === null || _this$userProfileMode12 === void 0 ? void 0 : _this$userProfileMode12.resetPasswordConfirmNewPassword,
                  // below values will come from deep link
                  uid: uid,
                  fptoken: fptoken
                };
                _context50.next = 4;
                return handle(DPServices.User.resetPassword(payload));

              case 4:
                _yield$handle19 = _context50.sent;
                _yield$handle20 = _slicedToArray(_yield$handle19, 2);
                err = _yield$handle20[0];
                response = _yield$handle20[1];

                if (!err) {
                  _context50.next = 19;
                  break;
                }

                errObj = err;
                faults = (_DPServices$Cart$pars = DPServices.Cart.parseErrors(errObj)) === null || _DPServices$Cart$pars === void 0 ? void 0 : _DPServices$Cart$pars.faults;
                haveErrorDescription = faults && faults[0] && faults[0].faultDescription;

                if (!haveErrorDescription) {
                  _context50.next = 16;
                  break;
                }

                throw new Error(haveErrorDescription);

              case 16:
                throw Errors.RESET_PASSWORD_FAILED;

              case 17:
                _context50.next = 26;
                break;

              case 19:
                _context50.next = 21;
                return this.saveCredentials(payload.login, payload.password, null);

              case 21:
                _context50.next = 23;
                return this.getCurrentUserProfile();

              case 23:
                userProfile = _context50.sent;
                _context50.next = 26;
                return this.postLogin(userProfile);

              case 26:
                _context50.next = 32;
                break;

              case 28:
                _context50.prev = 28;
                _context50.t0 = _context50["catch"](0);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context50.t0.message);
                throw _context50.t0;

              case 32:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this, [[0, 28]]);
      }));

      function resetPassword(_x22, _x23) {
        return _resetPassword.apply(this, arguments);
      }

      return resetPassword;
    }()
  }, {
    key: "updateFavoriteLocation",
    value: function () {
      var _updateFavoriteLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(restaurantNum, favouriteLocationAction) {
        var _this$rootStore3, _this$rootStore3$rest;

        var jwtToken, favoriteParams, response, _err$errors, _err$errors$;

        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                _context51.next = 2;
                return this.ensureAuth();

              case 2:
                jwtToken = _context51.sent;
                favoriteParams = {
                  restaurantNum: restaurantNum,
                  favouriteLocationAction: favouriteLocationAction,
                  jwtToken: jwtToken
                };
                _context51.prev = 4;
                _context51.next = 7;
                return DPServices.User.updateFavoriteLocation(favoriteParams);

              case 7:
                response = _context51.sent;

                if (response) {
                  this.favoriteLocations = response;
                }

                _context51.next = 14;
                break;

              case 11:
                _context51.prev = 11;
                _context51.t0 = _context51["catch"](4);

                if (_context51.t0 instanceof DPServices.Errors.UIError) {
                  this.rootStore.appMessages.showError(favouriteLocationAction === "remove" ? ERROR_STRINGS.REMOVE_FAVORITE_LOCATION : ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, (_context51.t0 === null || _context51.t0 === void 0 ? void 0 : (_err$errors = _context51.t0.errors) === null || _err$errors === void 0 ? void 0 : (_err$errors$ = _err$errors[0]) === null || _err$errors$ === void 0 ? void 0 : _err$errors$.message) || Errors.UPDATE_FAVORITE_LOCATION);
                }

              case 14:
                (_this$rootStore3 = this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : (_this$rootStore3$rest = _this$rootStore3.restaurant) === null || _this$rootStore3$rest === void 0 ? void 0 : _this$rootStore3$rest.getUserLocations();

              case 15:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this, [[4, 11]]);
      }));

      function updateFavoriteLocation(_x24, _x25) {
        return _updateFavoriteLocation.apply(this, arguments);
      }

      return updateFavoriteLocation;
    }()
  }, {
    key: "getSettingsData",
    value: function () {
      var _getSettingsData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(settingType) {
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                return _context52.abrupt("return", DPServices.User.getSettings(settingType));

              case 1:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52);
      }));

      function getSettingsData(_x26) {
        return _getSettingsData.apply(this, arguments);
      }

      return getSettingsData;
    }()
  }, {
    key: "isDeviceVersionGreater",
    value: function isDeviceVersionGreater(myVersion, minVersionReq) {
      var s1 = myVersion === null || myVersion === void 0 ? void 0 : myVersion.split(".");
      var s2 = minVersionReq === null || minVersionReq === void 0 ? void 0 : minVersionReq.split(".");
      var maxLength = Math.max(s1 === null || s1 === void 0 ? void 0 : s1.length, s2 === null || s2 === void 0 ? void 0 : s2.length);

      if (maxLength) {
        for (var i = 0; i < maxLength; i++) {
          var a = i < (s1 === null || s1 === void 0 ? void 0 : s1.length) ? toInteger(s1[i]) : 0;
          var b = i < (s2 === null || s2 === void 0 ? void 0 : s2.length) ? toInteger(s2[i]) : 0;

          if (!isEqual(a, b)) {
            var compare = gt(a, b);
            return compare;
          }
        }

        return true;
      } else return false;
    }
  }, {
    key: "forceUpdateNeeded",
    value: function forceUpdateNeeded(currentAppVersion) {
      var _this$rootStore4, _this$rootStore4$comm, _this$rootStore4$comm2, _this$rootStore5, _this$rootStore5$plat, _this$rootStore6, _this$rootStore6$plat, _forceVersions$split$; // below line just to avoid force app update in Dev Environment


      if (__DEV__) {
        return false;
      }

      var _ref = ((_this$rootStore4 = this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$comm = _this$rootStore4.common) === null || _this$rootStore4$comm === void 0 ? void 0 : (_this$rootStore4$comm2 = _this$rootStore4$comm.appAttributes) === null || _this$rootStore4$comm2 === void 0 ? void 0 : _this$rootStore4$comm2.mobileApp) || {},
          ios = _ref.ios,
          android = _ref.android;

      var forceVersions = (this === null || this === void 0 ? void 0 : (_this$rootStore5 = this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$plat = _this$rootStore5.platformUtil) === null || _this$rootStore5$plat === void 0 ? void 0 : _this$rootStore5$plat.platformDetails().os) === "iOS" ? ios === null || ios === void 0 ? void 0 : ios.forceVersions : android === null || android === void 0 ? void 0 : android.forceVersions;
      var minVersion = (this === null || this === void 0 ? void 0 : (_this$rootStore6 = this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : (_this$rootStore6$plat = _this$rootStore6.platformUtil) === null || _this$rootStore6$plat === void 0 ? void 0 : _this$rootStore6$plat.platformDetails().os) === "iOS" ? ios === null || ios === void 0 ? void 0 : ios.minVersion : android === null || android === void 0 ? void 0 : android.minVersion;
      var forceUpdateNeeded = (_forceVersions$split$ = forceVersions === null || forceVersions === void 0 ? void 0 : forceVersions.split(",").map(function (forceVersion) {
        return forceVersion === currentAppVersion;
      }).includes(true)) !== null && _forceVersions$split$ !== void 0 ? _forceVersions$split$ : false;
      var isMinVersionGreater = minVersion ? !this.isDeviceVersionGreater(currentAppVersion, minVersion) : false;

      if (forceUpdateNeeded || isMinVersionGreater) {
        return true;
      }

      return false;
    }
  }, {
    key: "postLoginHelper",
    value: function () {
      var _postLoginHelper = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53() {
        var updatedUserProfile;
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                _context53.next = 2;
                return this.getCurrentUserProfile();

              case 2:
                updatedUserProfile = _context53.sent;
                _context53.next = 5;
                return this.postLogin(updatedUserProfile);

              case 5:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));

      function postLoginHelper() {
        return _postLoginHelper.apply(this, arguments);
      }

      return postLoginHelper;
    }()
  }, {
    key: "fetchAndUpdateUserProfile",
    value: function () {
      var _fetchAndUpdateUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54() {
        var _this30 = this;

        var _yield$handle21, _yield$handle22, error, updatedUserProfile;

        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                _context54.next = 2;
                return handle(this.getCurrentUserProfile());

              case 2:
                _yield$handle21 = _context54.sent;
                _yield$handle22 = _slicedToArray(_yield$handle21, 2);
                error = _yield$handle22[0];
                updatedUserProfile = _yield$handle22[1];

                if (error) {// do nothing
                } else {
                  runInAction(function () {
                    _this30.rootStore.user.userProfile = updatedUserProfile;
                  });
                }

              case 7:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this);
      }));

      function fetchAndUpdateUserProfile() {
        return _fetchAndUpdateUserProfile.apply(this, arguments);
      }

      return fetchAndUpdateUserProfile;
    }()
  }, {
    key: "getLocationServiceStatus",
    value: function getLocationServiceStatus() {
      if (this.foreGroundLocationPermissions.granted && this.backGroundLocationPermissions.granted) {
        return LocationServiceStatus.ALWAYS;
      } else if (this.foreGroundLocationPermissions.granted) {
        return LocationServiceStatus.WHILE_USING_THE_APP;
      } else if (this.foreGroundLocationPermissions.canAskAgain || this.backGroundLocationPermissions.canAskAgain) {
        return LocationServiceStatus.ASK_NEXT_TIME;
      } else {
        return LocationServiceStatus.NEVER;
      }
    }
  }, {
    key: "getPreferredRestaurantDetails",
    value: function () {
      var _getPreferredRestaurantDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55() {
        var _this$rootStore7, _this$rootStore7$menu;

        var preferredRestaurant;
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                preferredRestaurant = (_this$rootStore7 = this.rootStore) === null || _this$rootStore7 === void 0 ? void 0 : (_this$rootStore7$menu = _this$rootStore7.menuList) === null || _this$rootStore7$menu === void 0 ? void 0 : _this$rootStore7$menu.processUserPreferredLocations();

                if (preferredRestaurant) {
                  this.userProfileModel.setPreferredRestaurantDetails(preferredRestaurant);
                }

              case 2:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));

      function getPreferredRestaurantDetails() {
        return _getPreferredRestaurantDetails.apply(this, arguments);
      }

      return getPreferredRestaurantDetails;
    }()
  }, {
    key: "getReservations",
    value: function () {
      var _getReservations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56() {
        var _this$userProfile10, resp, _this$userProfileMode13, _resp$activeReservati;

        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                _context56.prev = 0;
                _context56.next = 3;
                return DPServices.Reservation.getReservations({
                  email: (_this$userProfile10 = this.userProfile) === null || _this$userProfile10 === void 0 ? void 0 : _this$userProfile10.login
                });

              case 3:
                resp = _context56.sent;

                if (resp.activeReservations) {
                  (_this$userProfileMode13 = this.userProfileModel) === null || _this$userProfileMode13 === void 0 ? void 0 : _this$userProfileMode13.setNumberOfActiveReservations(resp === null || resp === void 0 ? void 0 : (_resp$activeReservati = resp.activeReservations) === null || _resp$activeReservati === void 0 ? void 0 : _resp$activeReservati.length);
                }

                _context56.next = 9;
                break;

              case 7:
                _context56.prev = 7;
                _context56.t0 = _context56["catch"](0);

              case 9:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this, [[0, 7]]);
      }));

      function getReservations() {
        return _getReservations.apply(this, arguments);
      }

      return getReservations;
    }()
  }, {
    key: "doLogin",
    value: function () {
      var _doLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57() {
        var _this31 = this;

        var isCreateAccountFlow,
            response,
            _err$includes,
            _err$includes2,
            _error$errors,
            _error$errors$,
            _error$errors2,
            _error$errors2$,
            err,
            _args57 = arguments;

        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                isCreateAccountFlow = _args57.length > 0 && _args57[0] !== undefined ? _args57[0] : false;
                _context57.prev = 1;

                if (!this.isAuthInProgress) {
                  _context57.next = 4;
                  break;
                }

                return _context57.abrupt("return");

              case 4:
                runInAction(function () {
                  _this31._authInProgress = true;
                });
                _context57.next = 7;
                return this.rootStore.platformUtil.authenticateUser(isCreateAccountFlow);

              case 7:
                response = _context57.sent;
                this.userProfileModel.showPreferredLocationSelectionAfterCreateAccount = response === null || response === void 0 ? void 0 : response.isNewUser; // This will differentiate b/w the socail and normal create account confirmation flow

                this.userProfileModel.isSocialFlow = response === null || response === void 0 ? void 0 : response.isSocialFlow;
                _context57.next = 12;
                return this.refreshCurrentUserProfile(response === null || response === void 0 ? void 0 : response.accessToken);

              case 12:
                _context57.next = 14;
                return this.refreshSessionDetails();

              case 14:
                runInAction(function () {
                  _this31.isAuthenticated = true;
                  _this31._authInProgress = false;
                });
                _context57.next = 26;
                break;

              case 17:
                _context57.prev = 17;
                _context57.t0 = _context57["catch"](1);

                if (_context57.t0 instanceof DPServices.Errors.UIError) {
                  this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "Authentication failed", {
                    faultDescription: _context57.t0 === null || _context57.t0 === void 0 ? void 0 : (_error$errors = _context57.t0.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : _error$errors$.code,
                    faultCode: _context57.t0 === null || _context57.t0 === void 0 ? void 0 : (_error$errors2 = _context57.t0.errors) === null || _error$errors2 === void 0 ? void 0 : (_error$errors2$ = _error$errors2[0]) === null || _error$errors2$ === void 0 ? void 0 : _error$errors2$.message
                  });
                }

                runInAction(function () {
                  _this31.isAuthenticated = false;
                  _this31._authInProgress = false;
                });
                err = _context57.t0 !== null && _context57.t0 !== void 0 ? _context57.t0 : "";
                console.log("Error in signInUsingAzureB2C : ", _context57.t0 === null || _context57.t0 === void 0 ? void 0 : _context57.t0.message);

                if (!(err !== null && err !== void 0 && (_err$includes = err.includes) !== null && _err$includes !== void 0 && _err$includes.call(err, "cancelled") || err !== null && err !== void 0 && (_err$includes2 = err.includes) !== null && _err$includes2 !== void 0 && _err$includes2.call(err, "Aa."))) {
                  _context57.next = 25;
                  break;
                }

                return _context57.abrupt("return");

              case 25:
                this.rootStore.appMessages.showError("Authentication Failed!", _context57.t0, null, {
                  undismissible: false,
                  okBtnText: "OK"
                });

              case 26:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this, [[1, 17]]);
      }));

      function doLogin() {
        return _doLogin.apply(this, arguments);
      }

      return doLogin;
    }()
  }, {
    key: "trySilentLogin",
    value: function () {
      var _trySilentLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58() {
        var _this32 = this;

        var accessToken;
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                _context58.prev = 0;
                runInAction(function () {
                  _this32._authInProgress = true;
                });
                _context58.next = 4;
                return this.rootStore.platformUtil.trySilentAuthentication();

              case 4:
                accessToken = _context58.sent;

                if (!accessToken) {
                  _context58.next = 11;
                  break;
                }

                _context58.next = 8;
                return this.refreshCurrentUserProfile(accessToken);

              case 8:
                _context58.next = 10;
                return this.refreshSessionDetails();

              case 10:
                runInAction(function () {
                  _this32.isAuthenticated = true;
                });

              case 11:
                runInAction(function () {
                  _this32._authInProgress = false;
                });
                _context58.next = 18;
                break;

              case 14:
                _context58.prev = 14;
                _context58.t0 = _context58["catch"](0);
                runInAction(function () {
                  _this32._authInProgress = false;
                  _this32.isAuthenticated = false;
                });
                console.log("Error in silentSignInUsingAzureB2C : ", _context58.t0 === null || _context58.t0 === void 0 ? void 0 : _context58.t0.message);

              case 18:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this, [[0, 14]]);
      }));

      function trySilentLogin() {
        return _trySilentLogin.apply(this, arguments);
      }

      return trySilentLogin;
    }()
  }, {
    key: "signOutUsingAzureB2C",
    value: function () {
      var _signOutUsingAzureB2C = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59() {
        var _this33 = this;

        var retainQuery,
            _error$errors3,
            _error$errors3$,
            _error$errors4,
            _error$errors4$,
            _args59 = arguments;

        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                retainQuery = _args59.length > 0 && _args59[0] !== undefined ? _args59[0] : false;
                _context59.prev = 1;

                if (!this.isAuthInProgress) {
                  _context59.next = 4;
                  break;
                }

                return _context59.abrupt("return");

              case 4:
                runInAction(function () {
                  _this33._authInProgress = true;
                });
                this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "my account|logout", {});
                _context59.next = 8;
                return this.rootStore.platformUtil.signOutUser(retainQuery);

              case 8:
                runInAction(function () {
                  _this33._authInProgress = false;
                });
                _context59.next = 17;
                break;

              case 11:
                _context59.prev = 11;
                _context59.t0 = _context59["catch"](1);

                if (_context59.t0 instanceof DPServices.Errors.UIError) {
                  this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "my account|logout failed", {
                    faultDescription: _context59.t0 === null || _context59.t0 === void 0 ? void 0 : (_error$errors3 = _context59.t0.errors) === null || _error$errors3 === void 0 ? void 0 : (_error$errors3$ = _error$errors3[0]) === null || _error$errors3$ === void 0 ? void 0 : _error$errors3$.code,
                    faultCode: _context59.t0 === null || _context59.t0 === void 0 ? void 0 : (_error$errors4 = _context59.t0.errors) === null || _error$errors4 === void 0 ? void 0 : (_error$errors4$ = _error$errors4[0]) === null || _error$errors4$ === void 0 ? void 0 : _error$errors4$.message
                  });
                }

                runInAction(function () {
                  _this33._authInProgress = false;
                });
                console.log("Error in signOutUsingAzureB2C : ", _context59.t0 === null || _context59.t0 === void 0 ? void 0 : _context59.t0.message);
                this.rootStore.appMessages.showError("Logout Error!", _context59.t0, null, {
                  undismissible: false,
                  okBtnText: "OK"
                });

              case 17:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this, [[1, 11]]);
      }));

      function signOutUsingAzureB2C() {
        return _signOutUsingAzureB2C.apply(this, arguments);
      }

      return signOutUsingAzureB2C;
    }() // This function makes sure that whenever called if user is logged in
    // there will be an valid access_token by aquiring the token silently.
    // If silent login fails, we ask for a force login.
    // either way this ensures that user should have a valid access_token and 401 unauth cases won't happen.

  }, {
    key: "ensureAuth",
    value: function () {
      var _ensureAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60() {
        var accessToken;
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.prev = 0;
                _context60.next = 3;
                return this.rootStore.platformUtil.trySilentAuthentication();

              case 3:
                accessToken = _context60.sent;
                return _context60.abrupt("return", accessToken);

              case 7:
                _context60.prev = 7;
                _context60.t0 = _context60["catch"](0);
                _context60.next = 11;
                return this.doLogin();

              case 11:
                return _context60.abrupt("return", "");

              case 12:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this, [[0, 7]]);
      }));

      function ensureAuth() {
        return _ensureAuth.apply(this, arguments);
      }

      return ensureAuth;
    }() // This function will return access token if user is logged in
    // else it will return null

  }, {
    key: "getTokenSilentIfLoggedIn",
    value: function () {
      var _getTokenSilentIfLoggedIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61() {
        var accessToken;
        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                _context61.prev = 0;
                _context61.next = 3;
                return this.rootStore.platformUtil.trySilentAuthentication();

              case 3:
                accessToken = _context61.sent;
                return _context61.abrupt("return", accessToken);

              case 7:
                _context61.prev = 7;
                _context61.t0 = _context61["catch"](0);
                return _context61.abrupt("return", null);

              case 10:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, this, [[0, 7]]);
      }));

      function getTokenSilentIfLoggedIn() {
        return _getTokenSilentIfLoggedIn.apply(this, arguments);
      }

      return getTokenSilentIfLoggedIn;
    }()
  }, {
    key: "doesExist",
    value: function doesExist(val) {
      if (val !== undefined && val !== null) {
        return true;
      }

      return false;
    }
  }, {
    key: "getSignUpSource",
    value: function getSignUpSource() {
      var _this34 = this;

      try {
        var signUpSources = JSON.parse(this.rootStore.common.appAttributes.configs.signUpSources);
        return signUpSources.find(function (element) {
          return element.channel === (_this34.joinEclubModel.isFromAppPunchout ? "APP" : "WEB") && element.page === "Join eClub Page";
        });
      } catch (err) {
        return null;
      }
    }
  }, {
    key: "performJoinEclub",
    value: function () {
      var _performJoinEclub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62() {
        var _this$getSignUpSource, payload, joinEclubModel, SignUpSource, userInfo, splittedDOB, _joinEclubModel$prefe, preferredRestaurantNumber, _this$userProfile11, _this$userProfile11$p, phone, _yield$handle23, _yield$handle24, error, response, errorUI, _response$data2, _this$rootStore$appMe, _this$rootStore8, _this$rootStore8$plat, _this$analyticsModel, _this$rootStore$appMe2;

        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                _context62.prev = 0;
                payload = {};
                joinEclubModel = this.joinEclubModel;
                SignUpSource = ((_this$getSignUpSource = this.getSignUpSource()) === null || _this$getSignUpSource === void 0 ? void 0 : _this$getSignUpSource.signupSource) || "DARDEN";

                if (this.doesExist(SignUpSource)) {
                  payload.signUpSource = SignUpSource;
                }

                payload.subscriptionStatus = "P";

                if (joinEclubModel.secondarySubscriptions.length > 0) {
                  payload.secondarySubscriptions = joinEclubModel.secondarySubscriptions;
                }

                userInfo = {};

                if (this.doesExist(joinEclubModel.firstName)) {
                  userInfo.firstName = joinEclubModel.firstName;
                }

                if (this.doesExist(joinEclubModel.lastName)) {
                  userInfo.lastName = joinEclubModel.lastName;
                }

                if (this.doesExist(joinEclubModel.email)) {
                  userInfo.email = joinEclubModel.email;
                }

                if (this.doesExist(joinEclubModel.zipCode)) {
                  Object.assign(userInfo, {
                    address: {
                      postalCode: Number(joinEclubModel.zipCode)
                    }
                  });
                }

                if (this.doesExist(joinEclubModel.dob)) {
                  splittedDOB = joinEclubModel.dob.split("/");
                  userInfo.dobMonth = parseInt(splittedDOB[0]);
                  userInfo.dobDay = parseInt(splittedDOB[1]);
                  userInfo.dobYear = parseInt(splittedDOB[2]);
                }

                if (joinEclubModel !== null && joinEclubModel !== void 0 && joinEclubModel.preferredLocationDetails) {
                  preferredRestaurantNumber = joinEclubModel === null || joinEclubModel === void 0 ? void 0 : (_joinEclubModel$prefe = joinEclubModel.preferredLocationDetails) === null || _joinEclubModel$prefe === void 0 ? void 0 : _joinEclubModel$prefe.restaurantNumber;

                  if (preferredRestaurantNumber) {
                    userInfo.preferredRestaurant = preferredRestaurantNumber;
                  }
                }

                if (this.userProfile) {
                  phone = (_this$userProfile11 = this.userProfile) === null || _this$userProfile11 === void 0 ? void 0 : (_this$userProfile11$p = _this$userProfile11.phones) === null || _this$userProfile11$p === void 0 ? void 0 : _this$userProfile11$p.find(function (phone) {
                    return phone.phoneType === "Mobile" || phone.phoneType === "Home" || phone.phoneType === "Business";
                  });

                  if (phone) {
                    userInfo.phoneNumber = phone.phoneNumber;
                    userInfo.phonetype = phone.phoneType;
                  }
                }

                Object.assign(payload, {
                  userInfo: userInfo
                });
                _context62.next = 18;
                return handle( //@ts-ignore
                DPServices.JoinEClub.setJoinEclub(payload));

              case 18:
                _yield$handle23 = _context62.sent;
                _yield$handle24 = _slicedToArray(_yield$handle23, 2);
                error = _yield$handle24[0];
                response = _yield$handle24[1];

                if (!error) {
                  _context62.next = 25;
                  break;
                }

                errorUI = DPServices.Common.handleUIErrorAndOverride(error, {
                  title: ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG,
                  message: Errors.JOIN_ECLUB_FAILED.message
                });
                throw errorUI;

              case 25:
                if (response) {
                  //@ts-ignore
                  if (response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.guestAlreadySubscribed) {
                    (_this$rootStore$appMe = this.rootStore.appMessages) === null || _this$rootStore$appMe === void 0 ? void 0 : _this$rootStore$appMe.showError(i18next.t("text.eclub.guest_already_subscribed_popup_heading", {
                      defaultValue: "Great news!"
                    }), i18next.t("text.eclub.guest_already_subscribed_popup_description", {
                      defaultValue: "You are already subscribed to the eClub and should be in on all the latest news, special offers and more!"
                    }));
                  } else {
                    (_this$rootStore8 = this.rootStore) === null || _this$rootStore8 === void 0 ? void 0 : (_this$rootStore8$plat = _this$rootStore8.platformUtil) === null || _this$rootStore8$plat === void 0 ? void 0 : _this$rootStore8$plat.dispatchEvent("AnalyticsEvent", "Form Submit", {
                      formType: this.joinEclubModel.isFromAppPunchout ? "eclub_punchout_App" : "eclub"
                    });
                    this === null || this === void 0 ? void 0 : (_this$analyticsModel = this.analyticsModel) === null || _this$analyticsModel === void 0 ? void 0 : _this$analyticsModel.processEClubEvent(payload.secondarySubscriptions, SignUpSource);
                    this.rootStore.platformUtil.goToURL("/customer-service/join-eclub/confirmation");
                  }
                }

                _context62.next = 31;
                break;

              case 28:
                _context62.prev = 28;
                _context62.t0 = _context62["catch"](0);

                if (_context62.t0.errorCode === "EC402") {
                  (_this$rootStore$appMe2 = this.rootStore.appMessages) === null || _this$rootStore$appMe2 === void 0 ? void 0 : _this$rootStore$appMe2.showError(i18next.t("text.eclub.guest_already_subscribed_popup_heading", {
                    defaultValue: "Great news!"
                  }), i18next.t("text.eclub.guest_already_subscribed_popup_description", {
                    defaultValue: "You are already subscribed to the eClub and should be in on all the latest news, special offers and more"
                  }));
                } else {
                  this.rootStore.appMessages.showError(_context62.t0.title, _context62.t0.message, null, {
                    undismissible: true,
                    okBtnText: "Okay"
                  });
                }

              case 31:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, this, [[0, 28]]);
      }));

      function performJoinEclub() {
        return _performJoinEclub.apply(this, arguments);
      }

      return performJoinEclub;
    }()
  }, {
    key: "dispatchEclubStartEvent",
    value: function () {
      var _dispatchEclubStartEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63() {
        var _this$rootStore9, _this$rootStore9$plat, _this$getSignUpSource2;

        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                (_this$rootStore9 = this.rootStore) === null || _this$rootStore9 === void 0 ? void 0 : (_this$rootStore9$plat = _this$rootStore9.platformUtil) === null || _this$rootStore9$plat === void 0 ? void 0 : _this$rootStore9$plat.dispatchEvent("AnalyticsEvent", "eClubOptinStart", {
                  signupChannel: ((_this$getSignUpSource2 = this.getSignUpSource()) === null || _this$getSignUpSource2 === void 0 ? void 0 : _this$getSignUpSource2.signupSource) || "DARDEN"
                });

              case 1:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this);
      }));

      function dispatchEclubStartEvent() {
        return _dispatchEclubStartEvent.apply(this, arguments);
      }

      return dispatchEclubStartEvent;
    }()
  }, {
    key: "handleEclubSignupCTAPress",
    value: function () {
      var _handleEclubSignupCTAPress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64() {
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                this.joinEclubModel.isSubmitClicked = this.joinEclubModel.isSubmitClicked + 1;

                if (this.joinEclubModel.isValid) {
                  this.joinEclubModel.isSubmitClicked = 0;
                  this.performJoinEclub();
                }

              case 2:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, this);
      }));

      function handleEclubSignupCTAPress() {
        return _handleEclubSignupCTAPress.apply(this, arguments);
      }

      return handleEclubSignupCTAPress;
    }()
    /**
     * populates joineclubmodel with user information if logged in to pre-populate the eclub form
     */

  }, {
    key: "populateJoinEclubModel",
    value: function populateJoinEclubModel() {
      var userProfile = this.userProfile;

      if (userProfile !== null && userProfile !== void 0 && userProfile.userId) {
        this.joinEclubModel.firstName = userProfile.firstName;
        this.joinEclubModel.email = userProfile.login;
        this.joinEclubModel.lastName = userProfile.lastName;
      }
    }
  }, {
    key: "performUnsubscribe",
    value: function () {
      var _performUnsubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65() {
        var _this$getSignUpSource3, joinEclubModel, payload, _yield$handle25, _yield$handle26, error, response, errorDescription, _this$rootStore$appMe3;

        return _regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                _context65.prev = 0;
                joinEclubModel = this.joinEclubModel;
                payload = {
                  signUpSource: ((_this$getSignUpSource3 = this.getSignUpSource()) === null || _this$getSignUpSource3 === void 0 ? void 0 : _this$getSignUpSource3.signupSource) || "DARDEN",
                  subscriptionStatus: "U",
                  userInfo: {
                    email: joinEclubModel.unsubEmail
                  }
                };
                _context65.next = 5;
                return handle(DPServices.JoinEClub.setJoinEclub(payload));

              case 5:
                _yield$handle25 = _context65.sent;
                _yield$handle26 = _slicedToArray(_yield$handle25, 2);
                error = _yield$handle26[0];
                response = _yield$handle26[1];

                if (!error) {
                  _context65.next = 12;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || error.message ? error : Errors.UNSUBSCRIBE_ECLUB_FAILED;
                throw errorDescription;

              case 12:
                if (response) {
                  this.joinEclubModel.hasUnsubscribedSuccessfully = true;
                }

                _context65.next = 18;
                break;

              case 15:
                _context65.prev = 15;
                _context65.t0 = _context65["catch"](0);
                (_this$rootStore$appMe3 = this.rootStore.appMessages) === null || _this$rootStore$appMe3 === void 0 ? void 0 : _this$rootStore$appMe3.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context65.t0.message);

              case 18:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65, this, [[0, 15]]);
      }));

      function performUnsubscribe() {
        return _performUnsubscribe.apply(this, arguments);
      }

      return performUnsubscribe;
    }()
  }, {
    key: "handleUnsubscribeSubmit",
    value: function () {
      var _handleUnsubscribeSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66() {
        return _regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                this.joinEclubModel.isUnsubscribeSubmitClicked = this.joinEclubModel.isUnsubscribeSubmitClicked + 1;

                if (this.joinEclubModel.isUnsubValid) {
                  this.joinEclubModel.isUnsubscribeSubmitClicked = 0;
                  this.performUnsubscribe();
                }

              case 2:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, this);
      }));

      function handleUnsubscribeSubmit() {
        return _handleUnsubscribeSubmit.apply(this, arguments);
      }

      return handleUnsubscribeSubmit;
    }()
  }, {
    key: "getJoinEClubSMSDetails",
    value: function getJoinEClubSMSDetails() {
      try {
        var _this$rootStore10, _this$rootStore10$com, _this$rootStore10$com2, _this$rootStore10$com3;

        var SMSDetails = (_this$rootStore10 = this.rootStore) === null || _this$rootStore10 === void 0 ? void 0 : (_this$rootStore10$com = _this$rootStore10.common) === null || _this$rootStore10$com === void 0 ? void 0 : (_this$rootStore10$com2 = _this$rootStore10$com.appAttributes) === null || _this$rootStore10$com2 === void 0 ? void 0 : (_this$rootStore10$com3 = _this$rootStore10$com2.configs) === null || _this$rootStore10$com3 === void 0 ? void 0 : _this$rootStore10$com3.joinEclubSMSSubscriptionDetails;

        if (SMSDetails) {
          return JSON.parse(SMSDetails);
        }

        return null;
      } catch (err) {
        return null;
      }
    }
  }, {
    key: "performSocialLoginJoinEClub",
    value: function () {
      var _performSocialLoginJoinEClub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67() {
        var _this$getSignUpSource4, _this$signUpModel$eCl, _this$signUpModel$dob, _this$signUpModel$res, _this$signUpModel$res2, _this$userProfile$log, payload, SignUpSource, userInfo, splittedDOB, errorUI;

        return _regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                _context67.prev = 0;
                payload = {};
                SignUpSource = ((_this$getSignUpSource4 = this.getSignUpSource()) === null || _this$getSignUpSource4 === void 0 ? void 0 : _this$getSignUpSource4.signupSource) || "DARDEN";

                if (this.doesExist(SignUpSource)) {
                  payload.signUpSource = SignUpSource;
                }

                payload.subscriptionStatus = "P";

                if ((_this$signUpModel$eCl = this.signUpModel.eClubSubscriptions) !== null && _this$signUpModel$eCl !== void 0 && _this$signUpModel$eCl.length) {
                  payload.secondarySubscriptions = this.signUpModel.eClubSubscriptions;
                }

                userInfo = {};

                if ((_this$signUpModel$dob = this.signUpModel.dob) !== null && _this$signUpModel$dob !== void 0 && _this$signUpModel$dob.toString().length) {
                  splittedDOB = moment(this.signUpModel.dob).format("DD/MM/YYYY").split("/");
                  userInfo.dobMonth = parseInt(splittedDOB[0]);
                  userInfo.dobDay = parseInt(splittedDOB[1]);
                  userInfo.dobYear = parseInt(splittedDOB[2]);
                }

                if ((_this$signUpModel$res = this.signUpModel.restaurantDetails) !== null && _this$signUpModel$res !== void 0 && (_this$signUpModel$res2 = _this$signUpModel$res.restaurantNum) !== null && _this$signUpModel$res2 !== void 0 && _this$signUpModel$res2.length) {
                  userInfo.preferredRestaurant = parseInt(this.signUpModel.restaurantDetails.restaurantNum);
                }

                if ((_this$userProfile$log = this.userProfile.login) !== null && _this$userProfile$log !== void 0 && _this$userProfile$log.length) {
                  userInfo.email = this.userProfile.login;
                }

                Object.assign(payload, {
                  userInfo: userInfo
                });
                _context67.next = 13;
                return handle( //@ts-ignore
                DPServices.JoinEClub.setJoinEclub(payload));

              case 13:
                _context67.next = 19;
                break;

              case 15:
                _context67.prev = 15;
                _context67.t0 = _context67["catch"](0);
                errorUI = DPServices.Common.handleUIErrorAndOverride(_context67.t0, {
                  title: ERROR_STRINGS.UNEXPECTED_ERROR,
                  message: Errors.JOIN_ECLUB_FAILED.message
                });
                this.rootStore.appMessages.showError(errorUI.title, errorUI.message, null, {
                  undismissible: true,
                  okBtnText: "Okay"
                });

              case 19:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, this, [[0, 15]]);
      }));

      function performSocialLoginJoinEClub() {
        return _performSocialLoginJoinEClub.apply(this, arguments);
      }

      return performSocialLoginJoinEClub;
    }()
  }, {
    key: "shouldAskBiometrics",
    value: function () {
      var _shouldAskBiometrics = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68() {
        return _regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                _context68.t0 = this.isLoggedIn;

                if (!_context68.t0) {
                  _context68.next = 5;
                  break;
                }

                _context68.next = 4;
                return this.rootStore.platformUtil.isBiometricsPromptShown();

              case 4:
                _context68.t0 = !_context68.sent;

              case 5:
                return _context68.abrupt("return", _context68.t0);

              case 6:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, this);
      }));

      function shouldAskBiometrics() {
        return _shouldAskBiometrics.apply(this, arguments);
      }

      return shouldAskBiometrics;
    }()
  }, {
    key: "favoriteLocations",
    get: function get() {
      return this._favoriteLocations;
    },
    set: function set(value) {
      var _this35 = this;

      runInAction(function () {
        _this35._favoriteLocations = value;
      });
    }
  }, {
    key: "showHomeScreenAlert",
    get: function get() {
      return this._showHomeScreenAlert;
    },
    set: function set(val) {
      var _this36 = this;

      runInAction(function () {
        _this36._showHomeScreenAlert = val;
      });
    }
  }, {
    key: "isHomeScreenAlertClosed",
    get: function get() {
      return this._isHomeScreenAlertClosed;
    },
    set: function set(val) {
      var _this37 = this;

      runInAction(function () {
        _this37._isHomeScreenAlertClosed = val;
      });
    }
  }, {
    key: "promptForLocationPermissions",
    get: function get() {
      if (this.foregroundLocationPermissionGranted || !this._promptForLocationPermissions) {
        return false;
      } else {
        return this._promptForLocationPermissions;
      }
    },
    set: function set(val) {
      var _this38 = this;

      runInAction(function () {
        _this38._promptForLocationPermissions = val;
      });
    }
  }, {
    key: "promptForPhotoLibraryPermissions",
    get: function get() {
      if (this.photoLibraryPermissionGranted || !this._promptForPhotoLibraryPermissions) {
        return false;
      } else {
        return this._promptForPhotoLibraryPermissions;
      }
    },
    set: function set(val) {
      var _this39 = this;

      runInAction(function () {
        _this39._promptForPhotoLibraryPermissions = val;
      });
    }
  }, {
    key: "isMobilePayAvailable",
    get: function get() {
      var appAttributes = this.rootStore.common.appAttributes;
      var isWebMobilePayLoginEnforced = appAttributes.isWebMobilePayLoginEnforced;
      var isMobilePayForVIPGuestsEnabled = appAttributes.isMobilePayForVIPGuestsEnabled;
      var userProfile = this.userProfile;

      if (isMobilePayForVIPGuestsEnabled) {
        return userProfile && !!userProfile.isMobilePayEnabled;
      } else {
        if (isWebMobilePayLoginEnforced) {
          return !!userProfile;
        } else {
          return true;
        }
      }
    }
  }, {
    key: "isLoggedIn",
    get: function get() {
      var _this$sessionDetails2, _this$sessionDetails3;

      var sessionDetailsLoggedIn = this.sessionDetails ? !((_this$sessionDetails2 = this.sessionDetails) !== null && _this$sessionDetails2 !== void 0 && (_this$sessionDetails3 = _this$sessionDetails2.profile) !== null && _this$sessionDetails3 !== void 0 && _this$sessionDetails3["transient"]) : false;
      var cloudB2cLoggedIn = this.rootStore.platformUtil.isUserLoggedIn(); // TODO: session details will be removed in future release.
      // Chage the return accordingly.

      return sessionDetailsLoggedIn && cloudB2cLoggedIn;
    }
  }, {
    key: "userPicture",
    get: function get() {
      var _this$loginModal2, _this$loginModal2$use, _this$userProfile12, _this$loginModal4, _this$loginModal4$soc;

      if (!this.isLoggedIn) {
        return null;
      }

      if ((_this$loginModal2 = this.loginModal) !== null && _this$loginModal2 !== void 0 && (_this$loginModal2$use = _this$loginModal2.userSelectedProfilePicture) !== null && _this$loginModal2$use !== void 0 && _this$loginModal2$use.url) {
        var _this$loginModal3;

        return (_this$loginModal3 = this.loginModal) === null || _this$loginModal3 === void 0 ? void 0 : _this$loginModal3.userSelectedProfilePicture;
      } else if (((_this$userProfile12 = this.userProfile) === null || _this$userProfile12 === void 0 ? void 0 : _this$userProfile12.login) === ((_this$loginModal4 = this.loginModal) === null || _this$loginModal4 === void 0 ? void 0 : (_this$loginModal4$soc = _this$loginModal4.socialProfile) === null || _this$loginModal4$soc === void 0 ? void 0 : _this$loginModal4$soc.email)) {
        var _this$loginModal5, _this$loginModal5$soc;

        return (_this$loginModal5 = this.loginModal) === null || _this$loginModal5 === void 0 ? void 0 : (_this$loginModal5$soc = _this$loginModal5.socialProfile) === null || _this$loginModal5$soc === void 0 ? void 0 : _this$loginModal5$soc.picture;
      } else {
        return null;
      }
    }
  }, {
    key: "foregroundLocationPermissionGranted",
    get: function get() {
      if (this.foreGroundLocationPermissions) {
        return this.foreGroundLocationPermissions.granted;
      } else {
        return false;
      }
    }
  }, {
    key: "backgroundLocationPermissionGranted",
    get: function get() {
      if (this.backGroundLocationPermissions) {
        return this.backGroundLocationPermissions.granted;
      } else {
        return false;
      }
    }
  }, {
    key: "pushNotificationPermissionGranted",
    get: function get() {
      if (this.pushNotificationAuthorizationStatus) {
        return this.pushNotificationAuthorizationStatus === PushNotificationAuthorizationStatus.AUTHORIZED;
      } else {
        return false;
      }
    }
  }, {
    key: "photoLibraryPermissionGranted",
    get: function get() {
      if (this.photoLibraryPermissionStatus) {
        return this.photoLibraryPermissionStatus === CapabilityPermissionStatus.GRANTED;
      } else {
        return false;
      }
    }
  }, {
    key: "alertFromRestaurantDetails",
    get: function get() {
      var _this$rootStore11,
          _this$rootStore11$res,
          _this$rootStore11$res2,
          _this$rootStore12,
          _this$rootStore12$res,
          _this$rootStore12$res2,
          _this40 = this;

      var appSystemAlertMessage = (_this$rootStore11 = this.rootStore) === null || _this$rootStore11 === void 0 ? void 0 : (_this$rootStore11$res = _this$rootStore11.restaurant) === null || _this$rootStore11$res === void 0 ? void 0 : (_this$rootStore11$res2 = _this$rootStore11$res.detail) === null || _this$rootStore11$res2 === void 0 ? void 0 : _this$rootStore11$res2.appSystemAlertMessage;
      var appSystemAlertURL = (_this$rootStore12 = this.rootStore) === null || _this$rootStore12 === void 0 ? void 0 : (_this$rootStore12$res = _this$rootStore12.restaurant) === null || _this$rootStore12$res === void 0 ? void 0 : (_this$rootStore12$res2 = _this$rootStore12$res.detail) === null || _this$rootStore12$res2 === void 0 ? void 0 : _this$rootStore12$res2.appSystemAlertURL;

      if (appSystemAlertMessage) {
        runInAction(function () {
          _this40.showHomeScreenAlert = true;
        });
        var obj = {
          appSystemAlertMessage: appSystemAlertMessage,
          appSystemAlertURL: appSystemAlertURL
        };
        return obj;
      }

      return null;
    }
  }, {
    key: "alertFromAppInit",
    get: function get() {
      var _this$rootStore13,
          _this$rootStore13$com,
          _this$rootStore13$com2,
          _this$rootStore14,
          _this$rootStore14$com,
          _this$rootStore14$com2,
          _this41 = this;

      var appSystemAlertMessage = (_this$rootStore13 = this.rootStore) === null || _this$rootStore13 === void 0 ? void 0 : (_this$rootStore13$com = _this$rootStore13.common) === null || _this$rootStore13$com === void 0 ? void 0 : (_this$rootStore13$com2 = _this$rootStore13$com.appAttributes) === null || _this$rootStore13$com2 === void 0 ? void 0 : _this$rootStore13$com2.appSystemAlertMessage;
      var appSystemAlertURL = (_this$rootStore14 = this.rootStore) === null || _this$rootStore14 === void 0 ? void 0 : (_this$rootStore14$com = _this$rootStore14.common) === null || _this$rootStore14$com === void 0 ? void 0 : (_this$rootStore14$com2 = _this$rootStore14$com.appAttributes) === null || _this$rootStore14$com2 === void 0 ? void 0 : _this$rootStore14$com2.appSystemAlertURL;

      if (appSystemAlertMessage) {
        runInAction(function () {
          _this41.showHomeScreenAlert = true;
        });
        var obj = {
          appSystemAlertMessage: appSystemAlertMessage,
          appSystemAlertURL: appSystemAlertURL
        };
        return obj;
      }

      return null;
    }
  }, {
    key: "restaurantNumToBeSavedInUserProfile",
    get: function get() {
      return this._restaurantNumToBeSavedInUserProfile;
    },
    set: function set(_restaurantNumToBeSavedInUserProfile) {
      var _this42 = this;

      runInAction(function () {
        _this42._restaurantNumToBeSavedInUserProfile = _restaurantNumToBeSavedInUserProfile;
      });
    }
  }, {
    key: "isOrderSummaryOpen",
    get: function get() {
      return this._isOrderSummaryOpen;
    },
    set: function set(value) {
      var _this43 = this;

      runInAction(function () {
        _this43._isOrderSummaryOpen = value;
      });
    }
  }, {
    key: "showSMSSection",
    get: function get() {
      var _this$rootStore$commo, _this$rootStore$commo2;

      if ((_this$rootStore$commo = this.rootStore.common.appAttributes) !== null && _this$rootStore$commo !== void 0 && (_this$rootStore$commo2 = _this$rootStore$commo.configs) !== null && _this$rootStore$commo2 !== void 0 && _this$rootStore$commo2.eclubSmsSubsEnable && this.getJoinEClubSMSDetails()) {
        return true;
      }

      return false;
    }
  }, {
    key: "eClubHideSecondarySubscriptionSection",
    get: function get() {
      var _this$rootStore$commo3, _this$rootStore$commo4;

      if (((_this$rootStore$commo3 = this.rootStore.common.appAttributes) === null || _this$rootStore$commo3 === void 0 ? void 0 : (_this$rootStore$commo4 = _this$rootStore$commo3.configs) === null || _this$rootStore$commo4 === void 0 ? void 0 : _this$rootStore$commo4.eclubHideSecondarySubsSection) === "true") {
        return true;
      }

      return false;
    }
  }, {
    key: "isAuthInProgress",
    get: function get() {
      return this._authInProgress;
    }
  }]);

  return User;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userProfile", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "profileResponse", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "savedCreds", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isAuthenticated", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "foreGroundLocationPermissions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "backGroundLocationPermissions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "deviceAuth", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "currentUserLocation", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_promptForLocationPermissions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "pushNotificationAuthorizationStatus", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "photoLibraryPermissionStatus", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_promptForPhotoLibraryPermissions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_showHomeScreenAlert", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_restaurantNumToBeSavedInUserProfile", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_isHomeScreenAlertClosed", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_isOrderSummaryOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_favoriteLocations", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_authInProgress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "favoriteLocations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "favoriteLocations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showHomeScreenAlert", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showHomeScreenAlert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isHomeScreenAlertClosed", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isHomeScreenAlertClosed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "promptForLocationPermissions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "promptForLocationPermissions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "promptForPhotoLibraryPermissions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "promptForPhotoLibraryPermissions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dissmissPromptForLocationPermissions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dissmissPromptForLocationPermissions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dismissPromptForPhotoLibraryPermissions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dismissPromptForPhotoLibraryPermissions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMobilePayAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMobilePayAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLoggedIn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoggedIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userPicture", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userPicture"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "foregroundLocationPermissionGranted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "foregroundLocationPermissionGranted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "backgroundLocationPermissionGranted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "backgroundLocationPermissionGranted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pushNotificationPermissionGranted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pushNotificationPermissionGranted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "photoLibraryPermissionGranted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "photoLibraryPermissionGranted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "whenAppActive", [action], Object.getOwnPropertyDescriptor(_class.prototype, "whenAppActive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alertFromRestaurantDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "alertFromRestaurantDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alertFromAppInit", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "alertFromAppInit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantNumToBeSavedInUserProfile", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantNumToBeSavedInUserProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderSummaryOpen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderSummaryOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSMSSection", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showSMSSection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "eClubHideSecondarySubscriptionSection", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "eClubHideSecondarySubscriptionSection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAuthInProgress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAuthInProgress"), _class.prototype)), _class);
export { User as default };